// [autogen: artifact] AUTOMATICALLY GENERATED FILE. NOT DO EDIT BY HAND.

import { gql } from '@kazoohr/graphql';
import * as ApolloReactCommon from '@kazoohr/graphql/common';
import * as ApolloReactHooks from '@kazoohr/graphql/hooks';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Upload: any;
  /** All dates within this schema are ISO-8601 strings without time or timezone. */
  Date: any;
  /** All date-times are supposed to be are ISO-8601 strings, but we do accept input in other formats.  That behavior will change and we will replace Date and DateTime's behavior with that of StrictDate. */
  DateTime: any;
  /** A datetime input and output type only accepts ISO-8601 dates. */
  StrictDateTimeInput: String;
  /** General-use Upload input scalar */
  FileToUpload: any;
  /** General-use scalar to use for fields of JSON data. See https://www.npmjs.com/package/graphql-type-json for more information. */
  JSONObject: any;
  /** Represents a rich text document in its native ProseMirror document format. This is a JSON object with a specific schema. Use a TipTap editor instance from the @kazoohr/richtext-components package to interact with this format. */
  RichTextDocument: any;
}

export interface Query {
  __typename?: 'Query';
  /** Fetch the current authenticated user */
  currentUser: User;
  /** Fetch a user by ID (platform admin only) */
  user: User;
  nextQuestion: NextQuestionResponse;
  nextSolutionQuestion?: Maybe<Question>;
  session: Session;
  /** Fetch an idea (issue, opportunity, or praise) by ID. */
  idea?: Maybe<Idea>;
  question: Question;
  questions: Array<Question>;
  participantAnswers: Array<Question>;
  participant?: Maybe<Participant>;
  participants: Array<Participant>;
  sessions: SessionsConnection;
  feedback: FeedbackConnection;
  sessionInsights: SessionInsightsResult;
  /** Fetch attribute templates for the current user */
  sessionAttributeTemplates: SessionAttributeTemplatesConnection;
  /** Fetch all users (platform admin only) */
  users: UsersConnection;
  /** Fetch users for a specific organization (admin only) */
  organizationUsers: UsersConnection;
  /** Fetch all available organizations */
  organizations: OrganizationsConnection;
  accessCapabilities: AccessCapabilities;
  apiPing: Scalars['String'];
}


export interface QueryUserArgs {
  id: Scalars['ID'];
}


export interface QueryNextQuestionArgs {
  sessionId: Scalars['ID'];
}


export interface QueryNextSolutionQuestionArgs {
  solutionSessionId: Scalars['ID'];
}


export interface QuerySessionArgs {
  id: Scalars['ID'];
}


export interface QueryIdeaArgs {
  id: Scalars['ID'];
}


export interface QueryQuestionArgs {
  id: Scalars['ID'];
}


export interface QueryQuestionsArgs {
  filter: QuestionsFilterInput;
  sort?: InputMaybe<Array<QuestionsSortInput>>;
}


export interface QueryParticipantAnswersArgs {
  filter: ParticipantAnswersFilterInput;
}


export interface QueryParticipantArgs {
  sessionId: Scalars['ID'];
  participantId: Scalars['ID'];
}


export interface QueryParticipantsArgs {
  filter: ParticipantsFilterInput;
  sort?: InputMaybe<Array<ParticipantsSortInput>>;
}


export interface QuerySessionsArgs {
  filter?: InputMaybe<SessionsFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SessionsSortInput>>;
}


export interface QueryFeedbackArgs {
  filter: FeedbackFilterInput;
}


export interface QuerySessionInsightsArgs {
  sessionId: Scalars['ID'];
}


export interface QuerySessionAttributeTemplatesArgs {
  filter?: InputMaybe<SessionAttributeTemplatesFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
}


export interface QueryUsersArgs {
  filter?: InputMaybe<UsersFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<UsersSortInput>>;
}


export interface QueryOrganizationUsersArgs {
  organizationId: Scalars['ID'];
  filter?: InputMaybe<OrganizationUsersFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<OrganizationUsersSortInput>>;
}


export interface QueryOrganizationsArgs {
  filter?: InputMaybe<OrganizationsFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
}

export interface Mutation {
  __typename?: 'Mutation';
  startSession: StartSessionPayload;
  createSession: CreateSessionPayload;
  updateSession: UpdateSessionPayload;
  duplicateSession: DuplicateSessionPayload;
  joinSession: JoinSessionPayload;
  answerTextQuestion: AnswerQuestionPayload;
  answerMultipleChoiceQuestion: AnswerQuestionPayload;
  answerBooleanQuestion: AnswerQuestionPayload;
  answerRankingQuestion: AnswerQuestionPayload;
  answerRatingScaleQuestion: AnswerQuestionPayload;
  skipQuestion: AnswerQuestionPayload;
  abandonQuestion: AbandonQuestionPayload;
  endSession: EndSessionPayload;
  skipToNextSection: SkipToNextSectionPayload;
  pauseSession: PauseSessionPayload;
  resumeSession: ResumeSessionPayload;
  createFeedback: CreateFeedbackPayload;
  saveVote: SaveVotePayload;
  regenerateSessionSummary: RegenerateSessionSummaryPayload;
  startSolutionForIdea: StartSolutionForIdeaPayload;
  answerSolutionQuestion: AnswerSolutionQuestionPayload;
  createSessionAttributeTemplate: CreateSessionAttributeTemplatePayload;
  updateSessionAttributeTemplate: UpdateSessionAttributeTemplatePayload;
  archiveSessionAttributeTemplate: ArchiveSessionAttributeTemplatePayload;
  sendInvitation: SendInvitationPayload;
  archiveUser: ArchiveUserPayload;
  addUserToOrganization: AddUserToOrganizationPayload;
  removeUserFromOrganization: RemoveUserFromOrganizationPayload;
  updateUserOrganizationRole: UpdateUserOrganizationRolePayload;
  createOrganization: CreateOrganizationPayload;
  updateOrganization: UpdateOrganizationPayload;
  deleteOrganization: DeleteOrganizationPayload;
  assignTopicOwnership: AssignTopicOwnershipPayload;
  removeTopicAssignment: RemoveTopicAssignmentPayload;
  sendInsightsEmail: SendInsightsEmailPayload;
  toggleCurrentUserPlatformAdmin: ToggleCurrentUserPlatformAdminPayload;
  apiPing: Scalars['String'];
}


export interface MutationStartSessionArgs {
  input: StartSessionInput;
}


export interface MutationCreateSessionArgs {
  input: CreateSessionInput;
}


export interface MutationUpdateSessionArgs {
  input: UpdateSessionInput;
}


export interface MutationDuplicateSessionArgs {
  input: DuplicateSessionInput;
}


export interface MutationJoinSessionArgs {
  input: JoinSessionInput;
}


export interface MutationAnswerTextQuestionArgs {
  input: AnswerTextQuestionInput;
}


export interface MutationAnswerMultipleChoiceQuestionArgs {
  input: AnswerMultipleChoiceQuestionInput;
}


export interface MutationAnswerBooleanQuestionArgs {
  input: AnswerBooleanQuestionInput;
}


export interface MutationAnswerRankingQuestionArgs {
  input: AnswerRankingQuestionInput;
}


export interface MutationAnswerRatingScaleQuestionArgs {
  input: AnswerRatingScaleQuestionInput;
}


export interface MutationSkipQuestionArgs {
  input: SkipQuestionInput;
}


export interface MutationAbandonQuestionArgs {
  input: AbandonQuestionInput;
}


export interface MutationEndSessionArgs {
  input: EndSessionInput;
}


export interface MutationSkipToNextSectionArgs {
  input: SkipToNextSectionInput;
}


export interface MutationPauseSessionArgs {
  input: PauseSessionInput;
}


export interface MutationResumeSessionArgs {
  input: ResumeSessionInput;
}


export interface MutationCreateFeedbackArgs {
  input: CreateFeedbackInput;
}


export interface MutationSaveVoteArgs {
  input: SaveVoteInput;
}


export interface MutationRegenerateSessionSummaryArgs {
  input: RegenerateSessionSummaryInput;
}


export interface MutationStartSolutionForIdeaArgs {
  input: StartSolutionForIdeaInput;
}


export interface MutationAnswerSolutionQuestionArgs {
  input: AnswerSolutionQuestionInput;
}


export interface MutationCreateSessionAttributeTemplateArgs {
  input: CreateSessionAttributeTemplateInput;
}


export interface MutationUpdateSessionAttributeTemplateArgs {
  input: UpdateSessionAttributeTemplateInput;
}


export interface MutationArchiveSessionAttributeTemplateArgs {
  input: ArchiveSessionAttributeTemplateInput;
}


export interface MutationSendInvitationArgs {
  input: SendInvitationInput;
}


export interface MutationArchiveUserArgs {
  input: ArchiveUserInput;
}


export interface MutationAddUserToOrganizationArgs {
  input: AddUserToOrganizationInput;
}


export interface MutationRemoveUserFromOrganizationArgs {
  input: RemoveUserFromOrganizationInput;
}


export interface MutationUpdateUserOrganizationRoleArgs {
  input: UpdateUserOrganizationRoleInput;
}


export interface MutationCreateOrganizationArgs {
  input: CreateOrganizationInput;
}


export interface MutationUpdateOrganizationArgs {
  input: UpdateOrganizationInput;
}


export interface MutationDeleteOrganizationArgs {
  input: DeleteOrganizationInput;
}


export interface MutationAssignTopicOwnershipArgs {
  input: AssignTopicOwnershipInput;
}


export interface MutationRemoveTopicAssignmentArgs {
  input: RemoveTopicAssignmentInput;
}


export interface MutationSendInsightsEmailArgs {
  input: SendInsightsEmailInput;
}

export interface OrganizationsConnection {
  __typename?: 'OrganizationsConnection';
  pageInfo: PageInfo;
  edges: Array<OrganizationsEdge>;
}

export interface OrganizationsEdge {
  __typename?: 'OrganizationsEdge';
  cursor: Scalars['String'];
  node: Organization;
}

export interface SessionSection {
  __typename?: 'SessionSection';
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  section: SessionSectionType;
  timeInSeconds: Scalars['Int'];
  timeRemaining?: Maybe<Scalars['Int']>;
}

export interface Session {
  __typename?: 'Session';
  id: Scalars['ID'];
  title: Scalars['String'];
  type: Scalars['String'];
  section?: Maybe<SessionSectionType>;
  sections: Array<SessionSection>;
  description?: Maybe<Scalars['String']>;
  status: SessionStatus;
  length: Scalars['Int'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  sessionTimeRemaining?: Maybe<Scalars['Int']>;
  sectionTimeRemaining?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  focus?: Maybe<Scalars['String']>;
  currentParticipantHasJoined: Scalars['Boolean'];
  /** Whether to allow experimental factor-based follow-up questions */
  allowExperimentalFactorQuestions: Scalars['Boolean'];
  /** Participant identification mode: REQUIRED, OPTIONAL, or ANONYMOUS */
  identificationMode: IdentificationMode;
  /** Attribute templates selected for this session to collect from participants */
  selectedAttributes: Array<SessionAttributeTemplate>;
  implementations: ImplementationsConnection;
  defaultQuestions: Array<Scalars['String']>;
  requireDefaultQuestions: Scalars['Boolean'];
  user: User;
  questions: Array<Question>;
  participants: ParticipantsConnection;
  feedback: FeedbackConnection;
  /** Live schema output data. Null if session has no output schema or current user is not the facilitator. */
  schemaOutput?: Maybe<Scalars['JSONObject']>;
  logs: Array<SessionLog>;
  /** AI-generated factor insights for this session with generation status. */
  factors?: Maybe<SessionFactors>;
}


export interface SessionImplementationsArgs {
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
}


export interface SessionQuestionsArgs {
  sort?: InputMaybe<Array<QuestionsSortInput>>;
}


export interface SessionParticipantsArgs {
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<ParticipantsSortInput>>;
  filter?: InputMaybe<SessionParticipantsFilterInput>;
}


export interface SessionFeedbackArgs {
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
}

/** Wrapper type for session factor insights including generation status. */
export interface SessionFactors {
  __typename?: 'SessionFactors';
  /** Current status of factor generation */
  status: SessionFactorGenerationStatus;
  /** The generated factor insights. Empty array if status is not 'GENERATED'. */
  factors: Array<SessionFactor>;
  /** Error message if status is 'ERRORED', null otherwise */
  error?: Maybe<Scalars['String']>;
}

/** Status of factor insights generation for a session. */
export type SessionFactorGenerationStatus =
  /** Task has been queued but not started */
  | 'ENQUEUED'
  /** Task is actively generating insights */
  | 'GENERATING'
  /** Generation completed successfully */
  | 'GENERATED'
  /** Generation failed with an error */
  | 'ERRORED';

/** AI-generated insights for a specific factor across all participants in a session. */
export interface SessionFactor {
  __typename?: 'SessionFactor';
  id: Scalars['ID'];
  /** The factor code (e.g., 'engagement_index', 'job_satisfaction') */
  factorCode: Scalars['String'];
  /** Human-readable factor name derived from the factor code */
  factorName: Scalars['String'];
  /** A 2-5 sentence plain text summary of the factor insights. No markdown formatting. */
  description: Scalars['String'];
  /** A detailed analysis (3-5 paragraphs) of the factor insights with Markdown formatting */
  analysis: Scalars['String'];
  /** Notable quotes from participants that illustrate the factor sentiment */
  quotes: Array<SessionFactorQuote>;
}

/** A quote from a participant that illustrates a factor's sentiment. */
export interface SessionFactorQuote {
  __typename?: 'SessionFactorQuote';
  /** The text of the quote */
  quote: Scalars['String'];
  /** The participant who said this quote */
  participant: Participant;
}

export interface SessionLog {
  __typename?: 'SessionLog';
  id: Scalars['ID'];
  sessionId: Scalars['String'];
  level: Scalars['String'];
  data: Scalars['String'];
  createdAt: Scalars['DateTime'];
}

export interface ImplementationsConnection {
  __typename?: 'ImplementationsConnection';
  pageInfo: PageInfo;
  edges: Array<ImplementationsEdge>;
}

export interface ImplementationsEdge {
  __typename?: 'ImplementationsEdge';
  cursor: Scalars['String'];
  node: Implementation;
}

export interface Implementation {
  __typename?: 'Implementation';
  id: Scalars['ID'];
  name: Scalars['String'];
  description: Scalars['String'];
  /** AI-generated detailed summary (markdown format). Null until enrichment completes. */
  summary?: Maybe<Scalars['String']>;
  score: Scalars['Int'];
  myVote?: Maybe<VoteType>;
  /** Exposed as a quick list for visualizations. Only accessible from the SessionInsights query. */
  linkedIssueIds: Array<Scalars['ID']>;
  /** Exposed as a quick list for visualizations. Only accessible from the SessionInsights query. */
  linkedOpportunityIds: Array<Scalars['ID']>;
  /** Exposed as a quick list for visualizations. Only accessible from the SessionInsights query. */
  linkedPraiseIds: Array<Scalars['ID']>;
  /** Exposed as a quick list for visualizations. Only accessible from the SessionInsights query. */
  linkedParticipantIds: Array<Scalars['ID']>;
}

export type UserOrganizationRole =
  | 'ADMIN'
  | 'MEMBER';

export type UserStatus =
  | 'ACTIVE'
  | 'INVITED'
  | 'ARCHIVED';

export interface Organization {
  __typename?: 'Organization';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  userCount: Scalars['Int'];
}

export interface UserOrganization {
  __typename?: 'UserOrganization';
  id: Scalars['ID'];
  user: User;
  organization: Organization;
  role: UserOrganizationRole;
}

export interface User {
  __typename?: 'User';
  id: Scalars['ID'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  /** Whether this user is a WorkTango platform admin. Only visible to other platform admins. */
  isPlatformAdmin?: Maybe<Scalars['Boolean']>;
  /** User source (workos or dev) */
  source: Scalars['String'];
  /** User account status. Only visible to admins. */
  status?: Maybe<UserStatus>;
  /** User creation timestamp */
  createdAt: Scalars['DateTime'];
  /** Organization memberships this user belongs to. */
  organizationMemberships: Array<UserOrganization>;
  /** The user's current organization. Only visible to self, as organization selection is a session-level concept setting. */
  organization?: Maybe<Organization>;
  /** Whether the user's organization is overridden for the current session. */
  organizationOverridden?: Maybe<Scalars['Boolean']>;
}

export interface Participant {
  __typename?: 'Participant';
  id: Scalars['ID'];
  name: Scalars['String'];
  title: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  /** Whether this participant joined anonymously */
  isAnonymous: Scalars['Boolean'];
  /** Attribute responses provided by this participant */
  attributeResponses: Array<ParticipantAttributeResponse>;
  /** Factor scores for this participant. Returns all factors including inconclusive ones. */
  factorScores: Array<ParticipantFactorScore>;
}

export interface ParticipantAttributeResponse {
  __typename?: 'ParticipantAttributeResponse';
  id: Scalars['ID'];
  /** The attribute template this response is for */
  attributeTemplate: SessionAttributeTemplate;
  /** The participant's response value */
  value: Scalars['String'];
}

export interface ParticipantFactorScore {
  __typename?: 'ParticipantFactorScore';
  id: Scalars['ID'];
  factorCode: Scalars['String'];
  factorName: Scalars['String'];
  sentiment: FactorSentiment;
  sentimentLabel: Scalars['String'];
  /** AI-generated summary. Only present for conclusive factors (positive/negative), null for inconclusive. */
  summary?: Maybe<Scalars['String']>;
}

/** Sentiment values for factor scores. Survey questions naturally surface problems, so 'positive' includes both clearly positive AND mixed/acceptable states. 'inconclusive' means insufficient data to assess. */
export type FactorSentiment =
  | 'POSITIVE'
  | 'NEGATIVE'
  | 'INCONCLUSIVE';

export interface Question {
  __typename?: 'Question';
  id: Scalars['ID'];
  content: QuestionContent;
  createdAt: Scalars['DateTime'];
  answer?: Maybe<Scalars['String']>;
  answeredAt?: Maybe<Scalars['DateTime']>;
  section: SessionSectionType;
  issues: Array<Issue>;
  opportunities: Array<Opportunity>;
  praise: Array<Praise>;
  implementations: Array<Implementation>;
}

export type QuestionContent = MultipleChoiceQuestionContent | TextQuestionContent | BooleanQuestionContent | RankingQuestionContent | RatingScaleQuestionContent;

export interface MultipleChoiceQuestionContent {
  __typename?: 'MultipleChoiceQuestionContent';
  preamble?: Maybe<Scalars['String']>;
  question: Scalars['String'];
  multipleChoiceOptions: Array<Scalars['String']>;
}

export interface TextQuestionContent {
  __typename?: 'TextQuestionContent';
  preamble?: Maybe<Scalars['String']>;
  question: Scalars['String'];
}

export interface BooleanQuestionContent {
  __typename?: 'BooleanQuestionContent';
  preamble?: Maybe<Scalars['String']>;
  question: Scalars['String'];
}

export interface RankingQuestionOption {
  __typename?: 'RankingQuestionOption';
  id: Scalars['ID'];
  text: Scalars['String'];
  description?: Maybe<Scalars['String']>;
}

export interface RankingQuestionContent {
  __typename?: 'RankingQuestionContent';
  preamble?: Maybe<Scalars['String']>;
  question: Scalars['String'];
  rankingOptions: Array<RankingQuestionOption>;
  rankingType?: Maybe<Scalars['String']>;
  issues: Array<Issue>;
  opportunities: Array<Opportunity>;
  praise: Array<Praise>;
}

export interface RatingScaleQuestionContent {
  __typename?: 'RatingScaleQuestionContent';
  preamble?: Maybe<Scalars['String']>;
  question: Scalars['String'];
  scaleType: RatingScaleType;
  minLabel: Scalars['String'];
  maxLabel: Scalars['String'];
}

export type RatingScaleType =
  | 'NUMERIC'
  | 'STARS';

export interface NextQuestionResponse {
  __typename?: 'NextQuestionResponse';
  question?: Maybe<Question>;
  session: Session;
}

export interface CreateSessionPayload {
  __typename?: 'CreateSessionPayload';
  session?: Maybe<Session>;
}

export interface UpdateSessionPayload {
  __typename?: 'UpdateSessionPayload';
  session?: Maybe<Session>;
}

export interface DuplicateSessionPayload {
  __typename?: 'DuplicateSessionPayload';
  session?: Maybe<Session>;
}

export interface AnswerQuestionPayload {
  __typename?: 'AnswerQuestionPayload';
  answer?: Maybe<Scalars['String']>;
  answeredAt?: Maybe<Scalars['DateTime']>;
  issues: Array<Issue>;
  opportunities: Array<Opportunity>;
  praise: Array<Praise>;
}

export interface StartSessionPayload {
  __typename?: 'StartSessionPayload';
  expiresAt?: Maybe<Scalars['DateTime']>;
}

export type SessionSectionType =
  | 'DISCUSSION'
  | 'GENERATING_IDEAS'
  | 'GENERATING_IMPLEMENTATIONS'
  | 'RANKING_IDEAS'
  | 'RANKING_IMPLEMENTATIONS'
  | 'VELOCITY';

export type SessionStatus =
  | 'DRAFT'
  | 'ACTIVE'
  | 'PAUSED'
  | 'COMPLETED'
  | 'ARCHIVED';

export type IdentificationMode =
  | 'REQUIRED'
  | 'OPTIONAL'
  | 'ANONYMOUS';

export interface AnswerTextQuestionInput {
  sessionId: Scalars['ID'];
  questionId: Scalars['ID'];
  answer: Scalars['String'];
}

export interface AnswerMultipleChoiceQuestionInput {
  sessionId: Scalars['ID'];
  questionId: Scalars['ID'];
  selectedOption: Scalars['String'];
}

export interface AnswerBooleanQuestionInput {
  sessionId: Scalars['ID'];
  questionId: Scalars['ID'];
  value: Scalars['Boolean'];
}

export interface RankedOption {
  id: Scalars['ID'];
}

export interface AnswerRankingQuestionInput {
  sessionId: Scalars['ID'];
  questionId: Scalars['ID'];
  rankedOptions: Array<RankedOption>;
}

export interface AnswerRatingScaleQuestionInput {
  sessionId: Scalars['ID'];
  questionId: Scalars['ID'];
  rating: Scalars['Int'];
}

export interface SkipQuestionInput {
  sessionId: Scalars['ID'];
  questionId: Scalars['ID'];
}

export interface AbandonQuestionInput {
  sessionId: Scalars['ID'];
  questionId: Scalars['ID'];
}

export interface AbandonQuestionPayload {
  __typename?: 'AbandonQuestionPayload';
  success: Scalars['Boolean'];
}

export interface CreateSessionInput {
  title: Scalars['String'];
  type: Scalars['String'];
  description: Scalars['String'];
  length: Scalars['Int'];
  focus?: InputMaybe<Scalars['String']>;
  defaultQuestions?: InputMaybe<Array<Scalars['String']>>;
  requireDefaultQuestions?: InputMaybe<Scalars['Boolean']>;
  allowExperimentalFactorQuestions?: InputMaybe<Scalars['Boolean']>;
  identificationMode?: InputMaybe<IdentificationMode>;
  selectedAttributeIds?: InputMaybe<Array<Scalars['ID']>>;
}

export interface UpdateSessionInput {
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  length?: InputMaybe<Scalars['Int']>;
  focus?: InputMaybe<Scalars['String']>;
  defaultQuestions?: InputMaybe<Array<Scalars['String']>>;
  requireDefaultQuestions?: InputMaybe<Scalars['Boolean']>;
  allowExperimentalFactorQuestions?: InputMaybe<Scalars['Boolean']>;
  identificationMode?: InputMaybe<IdentificationMode>;
  selectedAttributeIds?: InputMaybe<Array<Scalars['ID']>>;
}

export interface DuplicateSessionInput {
  id: Scalars['ID'];
}

export interface StartSessionInput {
  id: Scalars['ID'];
}

export interface JoinSessionInput {
  sessionId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  /** Attribute responses for session-configured attributes */
  attributeResponses?: InputMaybe<Array<AttributeResponseInput>>;
}

export interface AttributeResponseInput {
  attributeTemplateId: Scalars['ID'];
  value: Scalars['String'];
}

export interface JoinSessionPayload {
  __typename?: 'JoinSessionPayload';
  session: Session;
  participant?: Maybe<Participant>;
}

export interface QuestionsFilterInput {
  sessionId: Scalars['ID'];
}

export interface QuestionsSortInput {
  field: QuestionsSortField;
  direction?: InputMaybe<SortDirection>;
}

export type QuestionsSortField =
  | 'CREATED_AT';

export interface ParticipantAnswersFilterInput {
  sessionId: Scalars['ID'];
  participantId: Scalars['String'];
}

export interface ParticipantsFilterInput {
  sessionId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
}

export interface SessionParticipantsFilterInput {
  /** Filter by participant name (partial match, case-insensitive) */
  name?: InputMaybe<Scalars['String']>;
  /** Filter by participant email (partial match, case-insensitive) */
  email?: InputMaybe<Scalars['String']>;
  /** Filter by participant title (partial match, case-insensitive) */
  title?: InputMaybe<Scalars['String']>;
}

export interface ParticipantsSortInput {
  field: ParticipantsSortField;
  direction?: InputMaybe<SortDirection>;
}

export type ParticipantsSortField =
  | 'NAME'
  | 'EMAIL'
  | 'TITLE';

export interface SessionsConnection {
  __typename?: 'SessionsConnection';
  pageInfo: PageInfo;
  edges: Array<SessionsEdge>;
}

export interface SessionsEdge {
  __typename?: 'SessionsEdge';
  cursor: Scalars['String'];
  node: Session;
}

export interface SessionsFilterInput {
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
  statuses?: InputMaybe<Array<SessionStatus>>;
  title?: InputMaybe<Scalars['String']>;
}

export interface SessionsSortInput {
  field: SessionsSortField;
  direction?: InputMaybe<SortDirection>;
}

export type SessionsSortField =
  | 'CREATED_AT'
  | 'TITLE';

export interface ParticipantsConnection {
  __typename?: 'ParticipantsConnection';
  pageInfo: PageInfo;
  edges: Array<ParticipantsEdge>;
}

export interface ParticipantsEdge {
  __typename?: 'ParticipantsEdge';
  cursor: Scalars['String'];
  node: Participant;
}

export interface EndSessionInput {
  id: Scalars['ID'];
}

export interface EndSessionPayload {
  __typename?: 'EndSessionPayload';
  session?: Maybe<Session>;
}

export interface SkipToNextSectionInput {
  sessionId: Scalars['ID'];
}

export interface SkipToNextSectionPayload {
  __typename?: 'SkipToNextSectionPayload';
  session: Session;
  newSectionIndex: Scalars['Int'];
}

export interface CreateFeedbackInput {
  sessionId: Scalars['ID'];
  feedback: Scalars['String'];
  rating?: InputMaybe<Scalars['Int']>;
}

export interface Feedback {
  __typename?: 'Feedback';
  id: Scalars['ID'];
  feedback: Scalars['String'];
  rating?: Maybe<Scalars['Int']>;
  participant: Participant;
  createdAt: Scalars['DateTime'];
}

export interface CreateFeedbackPayload {
  __typename?: 'CreateFeedbackPayload';
  feedback?: Maybe<Feedback>;
}

export interface FeedbackConnection {
  __typename?: 'FeedbackConnection';
  pageInfo: PageInfo;
  edges: Array<FeedbackEdge>;
}

export interface FeedbackEdge {
  __typename?: 'FeedbackEdge';
  cursor: Scalars['String'];
  node: Feedback;
}

export interface FeedbackFilterInput {
  sessionId: Scalars['ID'];
  participantId?: InputMaybe<Scalars['String']>;
}

export interface SessionInsightsResult {
  __typename?: 'SessionInsightsResult';
  sessionInsights?: Maybe<SessionInsights>;
  wasTaskEnqueued: Scalars['Boolean'];
}

export interface SessionInsights {
  __typename?: 'SessionInsights';
  sessionSummary?: Maybe<SessionSummary>;
  issues: Array<Issue>;
  opportunities: Array<Opportunity>;
  praise: Array<Praise>;
  implementations: Array<Implementation>;
  participantCount: Scalars['Int'];
  duration: Scalars['Int'];
}

/** AI-generated summary of a session's key findings and themes. */
export interface SessionSummary {
  __typename?: 'SessionSummary';
  /**
   * Unique identifier for cache invalidation. When a summary is regenerated,
   * it gets a new ID, allowing Apollo Client to detect the change and update
   * the UI without showing stale cached data.
   */
  id: Scalars['ID'];
  positiveHighlights: Array<Scalars['String']>;
  areasForImprovement: Array<Scalars['String']>;
}

export interface Issue {
  __typename?: 'Issue';
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Short plain-text description (1-2 sentences) of the issue. */
  description: Scalars['String'];
  /** Detailed Markdown-formatted summary enriched with participant responses. */
  summary?: Maybe<Scalars['String']>;
  /** Absolute value of how many people concur with this issue. */
  score: Scalars['Int'];
  myVote?: Maybe<VoteType>;
  /** Exposed as a quick list for visualizations. Only accessible from the SessionInsights query. */
  linkedParticipantIds: Array<Scalars['ID']>;
  /** Email-based topic ownership assignments for this issue. */
  topicAssignments: Array<TopicAssignment>;
}

export interface Opportunity {
  __typename?: 'Opportunity';
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Short plain-text description (1-2 sentences) of the opportunity. */
  description: Scalars['String'];
  /** Detailed Markdown-formatted summary enriched with participant responses. */
  summary?: Maybe<Scalars['String']>;
  /** Absolute value of how many people concur with this opportunity. */
  score: Scalars['Int'];
  myVote?: Maybe<VoteType>;
  /** Exposed as a quick list for visualizations. Only accessible from the SessionInsights query. */
  linkedParticipantIds: Array<Scalars['ID']>;
  /** Email-based topic ownership assignments for this opportunity. */
  topicAssignments: Array<TopicAssignment>;
}

export interface Praise {
  __typename?: 'Praise';
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Short plain-text description (1-2 sentences) of the praise. */
  description: Scalars['String'];
  /** Detailed Markdown-formatted summary enriched with participant responses. */
  summary?: Maybe<Scalars['String']>;
  /** Absolute value of how many people concur with this praise. */
  score: Scalars['Int'];
  myVote?: Maybe<VoteType>;
  /** Exposed as a quick list for visualizations. Only accessible from the SessionInsights query. */
  linkedParticipantIds: Array<Scalars['ID']>;
  /** Email-based topic ownership assignments for this praise. */
  topicAssignments: Array<TopicAssignment>;
}

/** An idea can be an issue, opportunity, or praise. */
export type Idea = Issue | Opportunity | Praise;

export type VoteType =
  | 'UP'
  | 'NONE';

export type VotableEntityType =
  | 'IDEA'
  | 'IMPLEMENTATION';

export interface SaveVoteInput {
  sessionId: Scalars['ID'];
  entityType: VotableEntityType;
  entityId: Scalars['ID'];
  vote: VoteType;
}

export interface SaveVotePayload {
  __typename?: 'SaveVotePayload';
  success: Scalars['Boolean'];
  opportunity?: Maybe<Opportunity>;
  implementation?: Maybe<Implementation>;
  issue?: Maybe<Issue>;
  praise?: Maybe<Praise>;
}

export interface PauseSessionInput {
  sessionId: Scalars['ID'];
}

export interface PauseSessionPayload {
  __typename?: 'PauseSessionPayload';
  session: Session;
}

export interface ResumeSessionInput {
  sessionId: Scalars['ID'];
}

export interface ResumeSessionPayload {
  __typename?: 'ResumeSessionPayload';
  session: Session;
}

export interface RegenerateSessionSummaryInput {
  sessionId: Scalars['ID'];
}

export interface RegenerateSessionSummaryPayload {
  __typename?: 'RegenerateSessionSummaryPayload';
  success: Scalars['Boolean'];
  session: Session;
}

export interface StartSolutionForIdeaInput {
  sessionId: Scalars['ID'];
  ideaId: Scalars['ID'];
  initialSolution: Scalars['String'];
}

export interface StartSolutionForIdeaPayload {
  __typename?: 'StartSolutionForIdeaPayload';
  solutionSessionId: Scalars['ID'];
  nextQuestion?: Maybe<Question>;
}

export interface AnswerSolutionQuestionInput {
  solutionSessionId: Scalars['ID'];
  questionId: Scalars['ID'];
  answer: Scalars['String'];
}

export interface AnswerSolutionQuestionPayload {
  __typename?: 'AnswerSolutionQuestionPayload';
  solutionSessionId: Scalars['ID'];
  nextQuestion?: Maybe<Question>;
  isComplete: Scalars['Boolean'];
  questionsAnswered: Scalars['Int'];
}

export type SessionAttributeType =
  | 'DROPDOWN'
  | 'CUSTOM';

export interface SessionAttributeTemplate {
  __typename?: 'SessionAttributeTemplate';
  id: Scalars['ID'];
  name: Scalars['String'];
  type: SessionAttributeType;
  options: Array<Scalars['String']>;
  archived: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
}

export interface SessionAttributeTemplatesConnection {
  __typename?: 'SessionAttributeTemplatesConnection';
  pageInfo: PageInfo;
  edges: Array<SessionAttributeTemplatesEdge>;
}

export interface SessionAttributeTemplatesEdge {
  __typename?: 'SessionAttributeTemplatesEdge';
  cursor: Scalars['String'];
  node: SessionAttributeTemplate;
}

export interface SessionAttributeTemplatesFilterInput {
  name?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<SessionAttributeStatus>>;
  types?: InputMaybe<Array<SessionAttributeType>>;
}

export type SessionAttributeStatus =
  | 'ACTIVE'
  | 'ARCHIVED';

export interface CreateSessionAttributeTemplateInput {
  name: Scalars['String'];
  type: SessionAttributeType;
  options: Array<Scalars['String']>;
}

export interface CreateSessionAttributeTemplatePayload {
  __typename?: 'CreateSessionAttributeTemplatePayload';
  sessionAttributeTemplate: SessionAttributeTemplate;
}

export interface UpdateSessionAttributeTemplateInput {
  id: Scalars['ID'];
  name: Scalars['String'];
  type: SessionAttributeType;
  options: Array<Scalars['String']>;
  archived: Scalars['Boolean'];
}

export interface UpdateSessionAttributeTemplatePayload {
  __typename?: 'UpdateSessionAttributeTemplatePayload';
  sessionAttributeTemplate: SessionAttributeTemplate;
}

export interface ArchiveSessionAttributeTemplateInput {
  id: Scalars['ID'];
  archived: Scalars['Boolean'];
}

export interface ArchiveSessionAttributeTemplatePayload {
  __typename?: 'ArchiveSessionAttributeTemplatePayload';
  sessionAttributeTemplate: SessionAttributeTemplate;
}

export interface UsersConnection {
  __typename?: 'UsersConnection';
  pageInfo: PageInfo;
  edges: Array<UsersEdge>;
}

export interface UsersEdge {
  __typename?: 'UsersEdge';
  cursor: Scalars['String'];
  node: User;
}

export interface UsersFilterInput {
  search?: InputMaybe<Scalars['String']>;
}

export interface OrganizationsFilterInput {
  search?: InputMaybe<Scalars['String']>;
}

export interface UsersSortInput {
  field: UsersSortField;
  direction?: InputMaybe<SortDirection>;
}

export type UsersSortField =
  | 'EMAIL'
  | 'CREATED_AT';

export interface OrganizationUsersFilterInput {
  /** Filter by first name, last name, or email (partial match, case-insensitive) */
  search?: InputMaybe<Scalars['String']>;
  /** Filter by organization role(s) */
  roles?: InputMaybe<Array<UserOrganizationRole>>;
  /** Filter by user status(es) */
  statuses?: InputMaybe<Array<UserStatus>>;
}

export interface OrganizationUsersSortInput {
  field: OrganizationUsersSortField;
  direction?: InputMaybe<SortDirection>;
}

export type OrganizationUsersSortField =
  | 'NAME'
  | 'EMAIL'
  | 'CREATED_AT';

export interface SendInvitationInput {
  email: Scalars['String'];
}

export interface SendInvitationPayload {
  __typename?: 'SendInvitationPayload';
  invitationSent: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['String']>;
}

export interface SendInsightsEmailInput {
  sessionId: Scalars['ID'];
  emails: Array<Scalars['String']>;
}

export interface SendInsightsEmailPayload {
  __typename?: 'SendInsightsEmailPayload';
  success: Scalars['Boolean'];
  emailsSent: Scalars['Int'];
}

export interface ArchiveUserInput {
  userId: Scalars['ID'];
  archived: Scalars['Boolean'];
}

export interface ArchiveUserPayload {
  __typename?: 'ArchiveUserPayload';
  user: User;
}

export interface AddUserToOrganizationInput {
  userId: Scalars['ID'];
  organizationId: Scalars['ID'];
  role?: InputMaybe<UserOrganizationRole>;
}

export interface AddUserToOrganizationPayload {
  __typename?: 'AddUserToOrganizationPayload';
  userOrganization: UserOrganization;
}

export interface RemoveUserFromOrganizationInput {
  userId: Scalars['ID'];
  organizationId: Scalars['ID'];
}

export interface RemoveUserFromOrganizationPayload {
  __typename?: 'RemoveUserFromOrganizationPayload';
  success: Scalars['Boolean'];
}

export interface UpdateUserOrganizationRoleInput {
  userId: Scalars['ID'];
  organizationId: Scalars['ID'];
  role: UserOrganizationRole;
}

export interface UpdateUserOrganizationRolePayload {
  __typename?: 'UpdateUserOrganizationRolePayload';
  userOrganization: UserOrganization;
}

export interface CreateOrganizationInput {
  name: Scalars['String'];
}

export interface CreateOrganizationPayload {
  __typename?: 'CreateOrganizationPayload';
  organization: Organization;
}

export interface UpdateOrganizationInput {
  id: Scalars['ID'];
  name: Scalars['String'];
}

export interface UpdateOrganizationPayload {
  __typename?: 'UpdateOrganizationPayload';
  organization: Organization;
}

export interface DeleteOrganizationInput {
  id: Scalars['ID'];
}

export interface DeleteOrganizationPayload {
  __typename?: 'DeleteOrganizationPayload';
  success: Scalars['Boolean'];
}

/** An email-based topic ownership assignment for an idea. */
export interface TopicAssignment {
  __typename?: 'TopicAssignment';
  id: Scalars['ID'];
  /** The email address of the assigned owner. */
  email: Scalars['String'];
  /** The user ID of the person who created this assignment. */
  assignedByUserId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
}

export interface AssignTopicOwnershipInput {
  /** The session this idea belongs to. */
  sessionId: Scalars['ID'];
  /** The idea (issue, opportunity, or praise) to assign. */
  ideaId: Scalars['ID'];
  /** The email address of the person to assign as topic owner. */
  email: Scalars['String'];
}

export interface AssignTopicOwnershipPayload {
  __typename?: 'AssignTopicOwnershipPayload';
  topicAssignment: TopicAssignment;
  idea: Idea;
}

export interface RemoveTopicAssignmentInput {
  /** The IDs of the topic assignments to remove. */
  ids: Array<Scalars['ID']>;
}

export interface RemoveTopicAssignmentPayload {
  __typename?: 'RemoveTopicAssignmentPayload';
  success: Scalars['Boolean'];
  idea?: Maybe<Idea>;
}

export interface ToggleCurrentUserPlatformAdminPayload {
  __typename?: 'ToggleCurrentUserPlatformAdminPayload';
  user: User;
}

export interface AccessCapabilities {
  __typename?: 'AccessCapabilities';
  /** Not used, but required by Apollo Federation v2 to be a key field. */
  id: Scalars['ID'];
}

export interface NotificationSetting {
  __typename?: 'NotificationSetting';
  /** Key (which is unique) copied into the ID column for cache invalidation on the UI. */
  id: Scalars['ID'];
  /** Unique key identifying this notification setting */
  key: Scalars['String'];
  /** A localized translation value. */
  nameTranslation: Scalars['String'];
  /** An indicator of how to render these notification settings in grouped sections in the UI. */
  section: NotificationSettingUiSection;
  /** true: enabled. false: disabled. undefined: unset (use the API's default) */
  bell?: Maybe<Scalars['Boolean']>;
  /** true: enabled. false: disabled. undefined: unset (use the API's default) */
  actionItem?: Maybe<Scalars['Boolean']>;
  /** true: enabled. false: disabled. undefined: unset (use the API's default) */
  email?: Maybe<Scalars['Boolean']>;
}

export type NotificationSettingUiSection =
  | 'MAIN'
  | 'MANAGER_ENABLEMENT';

/** Represents some rich text content, which can be rendered in one of several formats. JSON is the native format; other formats are derived from it and may be lossy. */
export interface RichTextContent {
  __typename?: 'RichTextContent';
  /** The canonical representation of the rich text content, in ProseMirror JSON format. */
  json: Scalars['RichTextDocument'];
  /** The HTML representation of the rich text content, supporting a limited set of basic HTML formatting tags. Conversion to and from ProseMirror JSON may not be 1-to-1. */
  html: Scalars['String'];
  /** The plaintext representation of the rich text content. Any rich text formatting will be lost. */
  plaintext: Scalars['String'];
}

/** Represents a user's input for some rich text content. User input can be provided in one of several formats and will be sanitized and converted to a ProseMirror document if necessary. JSON inputs which do not conform to the ProseMirror schema will be rejected. */
export interface RichTextContentInput {
  json?: InputMaybe<Scalars['RichTextDocument']>;
  html?: InputMaybe<Scalars['String']>;
  plaintext?: InputMaybe<Scalars['String']>;
}

export interface PageInfo {
  __typename?: 'PageInfo';
  totalCount: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
  endCursor?: Maybe<Scalars['String']>;
}

export type SortDirection =
  | 'ASC'
  | 'DESC';

export interface Node {
  /** A globally unique identifier. */
  id: Scalars['ID'];
}

/** Used for calling out 'today's birthdays' without Kazoo storing actual DOB. */
export interface MonthDayInput {
  /** 2 digit month */
  month: Scalars['Int'];
  /** 2 digit day of month */
  day: Scalars['Int'];
  nullify?: InputMaybe<Scalars['Boolean']>;
}

export type DateFilterOperator =
  | 'DATE_EQUALS'
  | 'GREATER_THAN'
  | 'GREATER_THAN_OR_EQUAL_TO'
  | 'IS_NULL'
  | 'LESS_THAN'
  | 'LESS_THAN_OR_EQUAL_TO'
  /** For finding a date that matches the month and day of the value, but not the year. IE all anniversaries today regardless of year. */
  | 'MATCH_MONTH_AND_DAY_ANY_YEAR'
  | 'MATCH_MONTH_AND_DAY_GREATER_THAN_OR_EQUAL_ANY_YEAR'
  | 'MATCH_MONTH_AND_DAY_LESS_THAN_OR_EQUAL_ANY_YEAR';

export interface MonthDayFilter {
  operator: DateFilterOperator;
  value?: InputMaybe<MonthDayInput>;
}

export interface DateFilter {
  operator: DateFilterOperator;
  value?: InputMaybe<Scalars['Date']>;
}

export interface DateTimeFilter {
  operator: DateTimeFilterOperator;
  value?: InputMaybe<Scalars['DateTime']>;
}

export type DateTimeFilterOperator =
  | 'GREATER_THAN'
  | 'GREATER_THAN_OR_EQUAL_TO'
  | 'LESS_THAN'
  | 'LESS_THAN_OR_EQUAL_TO';

export interface HighGroundFeatureFlags {
  __typename?: 'HighGroundFeatureFlags';
  accessYEIRecognition?: Maybe<Scalars['Boolean']>;
  adhocGoal?: Maybe<Scalars['Boolean']>;
  adminInitiateFeedback?: Maybe<Scalars['Boolean']>;
  alertMissingPoint?: Maybe<Scalars['Boolean']>;
  allowCustomHRISFieldFiltering?: Maybe<Scalars['Boolean']>;
  allowSurveyKiosk?: Maybe<Scalars['Boolean']>;
  anonymousFeedback?: Maybe<Scalars['Boolean']>;
  answerLibrary?: Maybe<Scalars['Boolean']>;
  awaitingCommunication?: Maybe<Scalars['Boolean']>;
  brandedEmail?: Maybe<Scalars['Boolean']>;
  carryForwardGoals?: Maybe<Scalars['Boolean']>;
  certificateTemplates?: Maybe<Scalars['Boolean']>;
  colAdjustment?: Maybe<Scalars['Boolean']>;
  continuousFeedback?: Maybe<Scalars['Boolean']>;
  customProfanityFilter?: Maybe<Scalars['Boolean']>;
  customRole?: Maybe<Scalars['Boolean']>;
  defaultEverydayRecognition?: Maybe<Scalars['Boolean']>;
  disableFeatureByRole?: Maybe<Scalars['Boolean']>;
  disableMotivate?: Maybe<Scalars['Boolean']>;
  disableTracks?: Maybe<Scalars['Boolean']>;
  dontPersistCookies?: Maybe<Scalars['Boolean']>;
  emailFeedbackLink?: Maybe<Scalars['Boolean']>;
  enableAddPoints?: Maybe<Scalars['Boolean']>;
  enableBenchmarkSurvey?: Maybe<Scalars['Boolean']>;
  enableCheckInCalibration?: Maybe<Scalars['Boolean']>;
  enableCoaching?: Maybe<Scalars['Boolean']>;
  enableConversationGuide?: Maybe<Scalars['Boolean']>;
  enableDisplay?: Maybe<Scalars['Boolean']>;
  enableFeedback?: Maybe<Scalars['Boolean']>;
  enableGoals?: Maybe<Scalars['Boolean']>;
  enableLanguages?: Maybe<Scalars['Boolean']>;
  enableLocation?: Maybe<Scalars['Boolean']>;
  enableNineBox?: Maybe<Scalars['Boolean']>;
  enableOptOutPublicRec?: Maybe<Scalars['Boolean']>;
  enablePerform?: Maybe<Scalars['Boolean']>;
  enablePilotMembers?: Maybe<Scalars['Boolean']>;
  enablePoints?: Maybe<Scalars['Boolean']>;
  enablePolling?: Maybe<Scalars['Boolean']>;
  enablePulseSurvey?: Maybe<Scalars['Boolean']>;
  enableTeamTab?: Maybe<Scalars['Boolean']>;
  enableUserLanguage?: Maybe<Scalars['Boolean']>;
  enableVisibilityToAllSurveyData?: Maybe<Scalars['Boolean']>;
  feedback360?: Maybe<Scalars['Boolean']>;
  feedbackCheckin?: Maybe<Scalars['Boolean']>;
  forSalesDemo?: Maybe<Scalars['Boolean']>;
  giveFeedback?: Maybe<Scalars['Boolean']>;
  gmailPlugin?: Maybe<Scalars['Boolean']>;
  goalActivityWithActivity?: Maybe<Scalars['Boolean']>;
  goalCycleAdminHideDepartmentGoals?: Maybe<Scalars['Boolean']>;
  goalLibrary?: Maybe<Scalars['Boolean']>;
  goalWeighting?: Maybe<Scalars['Boolean']>;
  googleOAuth?: Maybe<Scalars['Boolean']>;
  grsInternalStoreFront?: Maybe<Scalars['Boolean']>;
  grsStorefront?: Maybe<Scalars['Boolean']>;
  hideAchievementLevelsDisplay?: Maybe<Scalars['Boolean']>;
  hideHelpLink?: Maybe<Scalars['Boolean']>;
  hidePasswordLogins?: Maybe<Scalars['Boolean']>;
  hideRecognitionByDepartment?: Maybe<Scalars['Boolean']>;
  hideRecognitionByLocation?: Maybe<Scalars['Boolean']>;
  hideSeeAllNotification?: Maybe<Scalars['Boolean']>;
  hideSelectAllWhenGivingRecognition?: Maybe<Scalars['Boolean']>;
  hideTermsOfUse?: Maybe<Scalars['Boolean']>;
  lamCustomReports?: Maybe<Scalars['Boolean']>;
  managerCheckInAnswerTypes?: Maybe<Scalars['Boolean']>;
  managerOnlySectionCheckin?: Maybe<Scalars['Boolean']>;
  managersSeePrivateBadge?: Maybe<Scalars['Boolean']>;
  managerTeamFeedback?: Maybe<Scalars['Boolean']>;
  managerTeamTabLearning?: Maybe<Scalars['Boolean']>;
  maskAnonymousReviewUser?: Maybe<Scalars['Boolean']>;
  mobileAccess?: Maybe<Scalars['Boolean']>;
  mobileAllowCompanyGoalMod?: Maybe<Scalars['Boolean']>;
  mobileAllowTeamGoalMod?: Maybe<Scalars['Boolean']>;
  mobileEmailSSOOverride?: Maybe<Scalars['Boolean']>;
  mobileSSOLogin?: Maybe<Scalars['Boolean']>;
  multiManager?: Maybe<Scalars['Boolean']>;
  notifyApproverGoalUpdates?: Maybe<Scalars['Boolean']>;
  openClosedGoal?: Maybe<Scalars['Boolean']>;
  outlookAddin?: Maybe<Scalars['Boolean']>;
  payrollAwardReport?: Maybe<Scalars['Boolean']>;
  payrollRedeemReport?: Maybe<Scalars['Boolean']>;
  performGoal?: Maybe<Scalars['Boolean']>;
  population?: Maybe<Scalars['Boolean']>;
  preventProfileInfoEditing?: Maybe<Scalars['Boolean']>;
  previewsEmbed?: Maybe<Scalars['Boolean']>;
  profanityFilter?: Maybe<Scalars['Boolean']>;
  publicAPI?: Maybe<Scalars['Boolean']>;
  publicRecFreeformComments?: Maybe<Scalars['Boolean']>;
  recognition2?: Maybe<Scalars['Boolean']>;
  recurringGoalCycle?: Maybe<Scalars['Boolean']>;
  relevancyFilter?: Maybe<Scalars['Boolean']>;
  reqFeedbackAboutOthers?: Maybe<Scalars['Boolean']>;
  requestFeedback?: Maybe<Scalars['Boolean']>;
  requireEmployeeID?: Maybe<Scalars['Boolean']>;
  restrictAvatarSetting?: Maybe<Scalars['Boolean']>;
  restrictChatWidget?: Maybe<Scalars['Boolean']>;
  restrictToSingleSession?: Maybe<Scalars['Boolean']>;
  rulesEngine?: Maybe<Scalars['Boolean']>;
  selectRecapTime?: Maybe<Scalars['Boolean']>;
  sendEmailsFromKazooDomain?: Maybe<Scalars['Boolean']>;
  sendRealEmails?: Maybe<Scalars['Boolean']>;
  sharedGoalsTab?: Maybe<Scalars['Boolean']>;
  shareLink?: Maybe<Scalars['Boolean']>;
  showPublicRecognitions?: Maybe<Scalars['Boolean']>;
  skipGoalApproval?: Maybe<Scalars['Boolean']>;
  spendCreditTransfer?: Maybe<Scalars['Boolean']>;
  spotBonus?: Maybe<Scalars['Boolean']>;
  suggestRewardIdea?: Maybe<Scalars['Boolean']>;
  syncUp?: Maybe<Scalars['Boolean']>;
  talentInsights?: Maybe<Scalars['Boolean']>;
  teamAnalytics?: Maybe<Scalars['Boolean']>;
  trackObjectiveWeight?: Maybe<Scalars['Boolean']>;
  turnOffTeam?: Maybe<Scalars['Boolean']>;
  unlimitedGiveBank?: Maybe<Scalars['Boolean']>;
  uploadGoalCycleParticipants?: Maybe<Scalars['Boolean']>;
  userNotificationPreference?: Maybe<Scalars['Boolean']>;
  workInProgress?: Maybe<Scalars['Boolean']>;
  yammerIntegration?: Maybe<Scalars['Boolean']>;
  hideLegacyAdminAnalytics?: Maybe<Scalars['Boolean']>;
}

export type HgMemberPermission =
  | 'AccessToAdminCustomLamReport'
  | 'AccessToManagerCustomLamReport'
  | 'AccessToPayrollRewardsReport'
  | 'AchievementRecognition'
  | 'AddGiftToNewRecognition'
  | 'AddGiftToOldRecognition'
  | 'AddPointsInRecognition'
  | 'AddRecognitionComment'
  | 'AdditionalBenchmarkCohortTypeReport'
  | 'AdhocGoal'
  | 'AdhocTeam'
  | 'AdminCompanyDashboard'
  | 'AdminFeedbackDashboard'
  | 'AdminGoalsDashboard'
  | 'AdminLevelProfileAccess'
  | 'AdminPointsDashboard'
  | 'AdminRecognitionDashboard'
  | 'AdminReports'
  | 'AdminTrackReportStatus'
  | 'AllImportantNotifications'
  | 'AllowAvatarUpload'
  | 'AllowChatWidget'
  | 'AllowProfileInfoEditing'
  | 'AllowSelectAllWhenGivingRecognition'
  | 'AllowSurveyKiosk'
  | 'AnonymousFeedback'
  | 'AnswerLibrary'
  | 'ApproveGoal'
  | 'AssignTrack'
  | 'AutomaticallySubmitEmployeeCheckIn'
  | 'BenchmarkSurvey'
  | 'COLAdjustment'
  | 'CanBeCreditAdmin'
  | 'CanBePointAdmin'
  | 'CanSeeRecognitionEmail'
  | 'CheckInCalibration'
  | 'CompanyAudit'
  | 'ContinuousFeedback'
  | 'CreateManagerOnlySectionCheckIn'
  | 'CreateTrack'
  | 'CreateTrackAddCredits'
  | 'CreateTrackAddPoints'
  | 'CreateTrackMoreOptions'
  | 'CreditTransactions'
  | 'CustomizedRecognition'
  | 'DefaultEverydayRecognition'
  | 'DeleteCoachingComment'
  | 'DeleteGoalComment'
  | 'DeleteRecognition'
  | 'DeleteRecognitionComment'
  | 'DonateToCharities'
  | 'DontPersistCookies'
  | 'EditRecognitionComment'
  | 'EditRecognitionMessage'
  | 'EmailFeedbackLink'
  | 'EnableConversationGuide'
  | 'EnableLanguages'
  | 'EnableOptOutPublicRec'
  | 'EnableUserLanguage'
  | 'EverydayRecognition'
  | 'ExportGroupData'
  | 'ExportMemberData'
  | 'ExpressPigeonSuppressedList'
  | 'Feedback360'
  | 'FeedbackCheckin'
  | 'ForSalesDemo'
  | 'GRSInternalStoreFront'
  | 'GRSStorefront'
  | 'GiveFeedback'
  | 'GivePointGift'
  | 'GiveRecognition'
  | 'GiveRecognitionToDepartment'
  | 'GiveRecognitionToLocation'
  | 'GmailPlugin'
  | 'Goal'
  | 'GoalCycleAdminHideDepartmentGoals'
  | 'GoalWeighting'
  | 'GoogleOAuth'
  | 'GroupCreditManagement'
  | 'GroupMemberEdit'
  | 'GroupMemberExport'
  | 'GroupMemberOffBoard'
  | 'GroupMemberOnboard'
  | 'GroupMemberTransferManager'
  | 'GroupSettingManagement'
  | 'GroupTerminologyManagement'
  | 'HGAdminReports'
  | 'HGManageTemplates'
  | 'HideAchievementLevelsDisplay'
  | 'HideHelpLink'
  | 'HidePasswordLogins'
  | 'HideRecognition'
  | 'HideTermsOfUse'
  | 'ImpersonateGlobal'
  | 'ImpersonateeShortList'
  | 'LamAdminSpotBonusReport'
  | 'LamManagerSpotBonusReport'
  | 'LikeGoalComment'
  | 'LikeRecognition'
  | 'LikeRecognitionComment'
  | 'ManageAPI'
  | 'ManageAchievementRecognition'
  | 'ManageAuthentication'
  | 'ManageBenchmarkSurvey'
  | 'ManageClientApi'
  | 'ManageCompanyNews'
  | 'ManageDepartment'
  | 'ManageDepartmentViewOnly'
  | 'ManageDisplay'
  | 'ManageEverydayRecognition'
  | 'ManageFeedback'
  | 'ManageGoalCycle'
  | 'ManageGoalLibrary'
  | 'ManageLocation'
  | 'ManageMilestoneRecognition'
  | 'ManagePointCycle'
  | 'ManagePointEconomy'
  | 'ManagePolls'
  | 'ManagePopulation'
  | 'ManageProductItem'
  | 'ManageProductOrder'
  | 'ManageProfanity'
  | 'ManagePulseSurvey'
  | 'ManageRecognitionSettings'
  | 'ManageRules'
  | 'ManageSlackIntegration'
  | 'ManageSpotBonus'
  | 'ManageSystemRecognition'
  | 'ManageTalentInsight'
  | 'ManageTrack'
  | 'ManageValuesRecognition'
  | 'ManagerCheckInAnswerTypes'
  | 'ManagerTeamFeedback'
  | 'ManagerTeamLearning'
  | 'MemberCredit'
  | 'MemberPoint'
  | 'MergeAccount'
  | 'MobileAllowCompanyGoalMod'
  | 'MobileAllowTeamGoalMod'
  | 'MonthlyInvoice'
  | 'MultiManager'
  | 'NotifyWhenBadPublicRecognition'
  | 'OpenClosedGoal'
  | 'OutlookAddin'
  | 'PasswordNeverExpires'
  | 'PaymentProfile'
  | 'PerformCardLibrary'
  | 'PerformCycle'
  | 'PerformGoal'
  | 'PerformNineBox'
  | 'PointStore'
  | 'Polls'
  | 'PopulationReporting'
  | 'PreviewsEmbed'
  | 'ProfileCoaching'
  | 'ProfileFeedback'
  | 'ProfilePerform'
  | 'ProvisionAssets'
  | 'ProvisionBilling'
  | 'ProvisionCompany'
  | 'ProvisionDemo'
  | 'ProvisionMetrics'
  | 'ProvisionSystem'
  | 'ProvisionTemplates'
  | 'PulseSurvey'
  | 'PurchaseCredits'
  | 'PurchaseGiftCards'
  | 'ReceiveCreditsInRecognition'
  | 'ReceiveGiftInRecognition'
  | 'ReceivePointsInBenchmarkSurvey'
  | 'ReceivePointsInPulseSurvey'
  | 'ReceivePointsInRecognition'
  | 'RecognizeMeLink'
  | 'RecurringGoalCycle'
  | 'RelevancyFilter'
  | 'ReportAnalytics'
  | 'ReqFeedbackAboutOthers'
  | 'RequestFeedback'
  | 'RequireEmployeeID'
  | 'RestrictReportsByLocation'
  | 'RestrictSurveyResultByLocation'
  | 'RestrictToSingleSession'
  | 'SeeAllCycles'
  | 'SeeAllFeedback'
  | 'SeeLocation'
  | 'SelectRecapTime'
  | 'SelfNotificationEmail'
  | 'SelfPreference'
  | 'SellMyOwnItemForPoints'
  | 'SendCreditsInRecognition'
  | 'SendPointsInRecognition'
  | 'SetPointAdmin'
  | 'ShareGoals'
  | 'ShareLink'
  | 'ShowPointsInPublicFeed'
  | 'SkipGoalApproval'
  | 'SpotBonus'
  | 'SuggestRewardIdea'
  | 'SwitchEnvironment'
  | 'SwitchEnvironmentHG'
  | 'SwitchEnvironmentQA'
  | 'SwitchEnvironmentSales'
  | 'SyncUp'
  | 'TeamAction'
  | 'TeamActionDemo'
  | 'TeamAnalyticsDownload'
  | 'TeamAnalyticsReport'
  | 'TeamCheckin'
  | 'TeamCoaching'
  | 'TeamGoals'
  | 'TeamManagement'
  | 'TeamPerform'
  | 'TeamRecognize'
  | 'TeamTabManagement'
  | 'TeamTalent'
  | 'TrackLibrary'
  | 'TrackObjectiveWeight'
  | 'Tracks'
  | 'TransferCredits'
  | 'TransferPoints'
  | 'TransferSpendCredits'
  | 'TrophyRoom'
  | 'UnlimitedGiveBank'
  | 'UploadGoalCycleParticipants'
  | 'UserNotificationPreference'
  | 'ValuesRecognition'
  | 'ViewAllCoachingNotes'
  | 'WishList'
  | 'YammerIntegration';

export type KazooModule =
  | 'BEHAVIOR_BONUS'
  | 'INCENTIVES'
  | 'KW_FEEDBACK'
  | 'KW_SYNC_UPS'
  | 'KW_TALENT_REVIEW'
  | 'LEGACY_AWARDS'
  | 'NEW_CHECK_INS'
  | 'NEW_GOALS'
  | 'REWARDS'
  | 'SURVEYS'
  | 'SYNC_UP';

export type KazooIcon =
  | 'ADD_USER'
  | 'ADMIN'
  | 'ANNIVERSARY'
  | 'ANNIVERSARY_CAL'
  | 'ARROW_LEFT'
  | 'ARROW_RIGHT'
  | 'BACK'
  | 'BELL'
  | 'BIRTHDAY'
  | 'BIRTHDAY_CAKE'
  | 'CALENDAR'
  | 'CARET_DN'
  | 'CARET_DOWN'
  | 'CARET_LEFT'
  | 'CARET_RIGHT'
  | 'CARET_UP'
  | 'CHECK'
  | 'CHECKMARK'
  | 'CHECK_IN'
  | 'CHECK_SEAL'
  | 'CLOCK'
  | 'CLOSE'
  | 'CLOUD_DOWNLOAD'
  | 'COMMENT'
  | 'COMPANY_LINKS'
  | 'DATEPICKER_NAV'
  | 'DOT'
  | 'DOWNLOAD'
  | 'DOWN_ARROW'
  | 'DRAG'
  | 'EARN'
  | 'EMAIL'
  | 'EXPIRED'
  | 'EYE'
  | 'FEEDBACK'
  | 'FILTER'
  | 'FILTER_MENU'
  | 'FIND'
  | 'FLAG'
  | 'GOALS'
  | 'GOAL_COUNT'
  | 'GOAL_PERCENT'
  | 'GOAL_TASK'
  | 'HAMBURGER'
  | 'HELP'
  | 'HIGH_FIVE'
  | 'HIGH_FIVE_HOLLOW'
  | 'HOME'
  | 'HORIZONTAL_LINE'
  | 'HOURGLASS'
  | 'IMAGE_FILE'
  | 'INCENTIVES'
  | 'INFO'
  | 'INSIGHTS'
  | 'LINK'
  | 'LINK_ARROW'
  | 'LINK_FEATURE'
  | 'LOCK'
  | 'MEATBALL_MENU'
  | 'NOMINATION'
  | 'NOTIFICATION'
  | 'OPEN_CARET'
  | 'OPEN_CARET_DOWN'
  | 'OPEN_CARET_LEFT'
  | 'OPEN_CARET_UP'
  | 'PENCIL'
  | 'PEOPLE'
  | 'PIN'
  | 'PLATFORM_LOGO'
  | 'PLUS'
  | 'PROGRESS_CIRCLE'
  | 'PUSH_PIN'
  | 'RATING'
  | 'RECOGNITION'
  | 'REMOVE'
  | 'REWARDS'
  | 'SEARCH'
  | 'SEND_RECOGNITION'
  | 'SHARE_LINK'
  | 'SKILL'
  | 'SMILEY'
  | 'SURVEY'
  | 'SURVEYS'
  | 'SYNCS'
  | 'TALENT_REVIEW'
  | 'TALENT_REVIEW_INSIGHTS'
  | 'TASK_COMPLETED'
  | 'TEAMS'
  | 'TEXT_BOLD'
  | 'TEXT_BULLETLIST'
  | 'TEXT_INPUT'
  | 'TEXT_ITALIC'
  | 'TEXT_NUMBERLIST'
  | 'TEXT_UNDERLINE'
  | 'TOGGLE'
  | 'TRASH'
  | 'TREND_DOWN'
  | 'TREND_UP'
  | 'UP_ARROW'
  | 'UP_DOWN_CARET'
  | 'VERTICAL_LINE'
  | 'WARNING'
  | 'WARNING_NO_OUTLINE';

export interface TranslationLinkInput {
  /** URL you'd like the split of the translation to link to */
  url: Scalars['String'];
  /** The split point in the translation value EG: for <0>Sent Recognition to</0> <1>{{ recipient }}</1>, the split would be 1. */
  translationSubstitutionIndex: Scalars['Int'];
}

export interface TranslationVariableInput {
  /** The variable name defined in content.json or common.json for a specific translation. */
  key: Scalars['String'];
  /** The value to be rendered in the translation. EG: Janet, Q4 Check-In, etc. */
  value: Scalars['String'];
  /** Optionally may provide a UUID. Useful for linking to something on the frontend. */
  translationLink?: InputMaybe<TranslationLinkInput>;
}

export type TranslationIdentifierTypes =
  | 'PERSON';

export type FieldOnEntityForTranslation =
  | 'PERSON_FULL_NAME';

export interface DynamicTranslationVariableInput {
  /** The name of the variable in the translation. */
  key: Scalars['String'];
  /** The entity type we want to query */
  identifierType: TranslationIdentifierTypes;
  /** The ID of the entity to query. */
  identifierId: Scalars['ID'];
  /** The field on that entity to be used as a translation variable. */
  fieldOnIdentifiedEntity: FieldOnEntityForTranslation;
  /** Optionally may provide a URL. Useful for linking to something on the frontend. */
  translationLink?: InputMaybe<TranslationLinkInput>;
}

/** Used to provide a translation key and and variables which can be used in translation function. */
export interface TranslatableObjectInput {
  /** Translation key. Should map to to known translation in content.json or common.json. If you provide any other string value it will render untranslated. */
  key: Scalars['String'];
  /** JSON object consisting of variables defined for a given translation. */
  variables?: InputMaybe<Array<TranslationVariableInput>>;
  dynamicVariables?: InputMaybe<Array<DynamicTranslationVariableInput>>;
}

export interface TranslationLink {
  __typename?: 'TranslationLink';
  /** URL you'd like the split of the translation to link to */
  url: Scalars['String'];
  /** The split point in the translation value EG: for <0>Sent Recognition to</0> <1>{{ recipient }}</1>, the split would be 1. */
  translationSubstitutionIndex: Scalars['Int'];
}

export interface TranslationVariable {
  __typename?: 'TranslationVariable';
  /** The variable name defined in content.json or common.json for a specific translation. */
  key: Scalars['String'];
  /** The value to be rendered in the translation. EG: Janet, Q4 Check-In, etc. */
  value: Scalars['String'];
  /** Optionally may provide a URL. Useful for linking to something on the frontend. */
  translationLink?: Maybe<TranslationLink>;
}

/** Returns a translation key and variables needed to translate. */
export interface TranslatableObject {
  __typename?: 'TranslatableObject';
  key: Scalars['String'];
  variables?: Maybe<Array<TranslationVariable>>;
  translatedValue?: Maybe<Scalars['String']>;
}

/** Represents an element that can be substituted into a translation. */
export interface TranslationValue {
  __typename?: 'TranslationValue';
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
}

export interface TranslatableError {
  __typename?: 'TranslatableError';
  message: Scalars['String'];
  translationKey: Scalars['String'];
  translationValues?: Maybe<Array<TranslationValue>>;
}

export type Role =
  | 'ADMIN'
  | 'ANALYST'
  | 'FINANCE'
  | 'FULFILLER'
  | 'PLATFORM_ADMIN'
  /** Can approve or reject rewards redemptions. */
  | 'REWARDS_MODERATOR'
  /** Deprecated. Use REWARDS_MODERATOR. */
  | 'REWARDS_MODERATORS'
  | 'SURVEY_ADMIN'
  /** Role that grants users UI access to Pulse app. Will also write back a pre-defined set of permissions within the Pulse app so that that WTW user can access certain features in Pulse. */
  | 'SURVEY_CUSTOM'
  /**
   * Sets a Full Report Reader in S&I.
   * Has access to view detailed reports for the Engagement survey type, including employee-level data, across all hierarchies.
   * This role can also filter reports using all attributes.
   */
  | 'SURVEY_FULL_REPORT_READER'
  /**
   * Sets a People Leader role in S&I.
   * Can manage and analyze engagement surveys, including viewing detailed reports filtered by various attributes, but their data access is limited to employees within their own hierarchy.
   * This role can also view and manage comments to understand employee sentiment.
   */
  | 'SURVEY_PEOPLE_LEADER'
  /**
   * Role that grants Pulse-only users access to the WorkTango AI Assistant admin
   * functionality.
   *
   * Some KW_USERS People who do not have this role will be treated as if they do if they have the WORKTANGO_COACH_ADMIN role in Pulse.
   * This allows SURVEY_CUSTOM permissions to define in the pulse app if a user can admin WorkTango Coach.
   */
  | 'WORKTANGO_COACH_ADMIN'
  /**
   * Role that grants users access to the WorkTango coach functionality.
   *
   * Some KW_USERS People who do not have this role will be treated as if they do if they have the WORKTANGO_COACH_USER role in Pulse.
   * This allows SURVEY_CUSTOM permissions to define in the pulse app if a user can use WorkTango Coach.
   */
  | 'WORKTANGO_COACH_USER';

export type PersonIdentityProvider =
  /** This is only supported for legacy CSV parsers that call imports.  Directory does not actually support default.  DO NOT USE. */
  | 'DEFAULT'
  /** Email.  Only unique within a company. */
  | 'EMAIL'
  /** EmployeeID, badge number or other value that is only unique within a company. */
  | 'EMPLOYEE_ID'
  /** GRS member id */
  | 'GRS_MEMBER_ID'
  /** globally unique identifier. Kazoo-assigned. */
  | 'KAZOO_ID'
  /** Legacy Highground userId */
  | 'LEGACY_HIGHGROUND_ID'
  /** Legacy Highground memberId */
  | 'LEGACY_HIGHGROUND_MEMBER_ID'
  /** Legacy Highground username */
  | 'LEGACY_HIGHGROUND_USERNAME'
  /** Employee Id from the legacy WorkTango platform Pulse */
  | 'LEGACY_PULSE_EMPLOYEE_ID'
  /** User Id from the legacy WorkTango platform Pulse */
  | 'LEGACY_PULSE_USER_ID'
  /** Legacy YouEarnedIt userId */
  | 'LEGACY_YEI_ID'
  /** Legacy YouEarnedIt username */
  | 'LEGACY_YEI_USERNAME'
  /** Kazoo Username */
  | 'USERNAME'
  /** WorkOS user id */
  | 'WORKOS_USER_ID';

export type QueryPeopleSortField =
  | 'BIRTHDAY'
  | 'DEPARTMENT_NAME'
  | 'EMPLOYMENT_START_DATE'
  | 'FULL_NAME'
  | 'LEGACY_FIRST_NAME'
  | 'LEGACY_LAST_NAME'
  | 'LOCATION_NAME'
  | 'POINTS_TO_SEND'
  | 'POINTS_TO_SPEND'
  | 'POINT_RULE'
  | 'STATUS'
  | 'TITLE';

export interface QueryPeopleSortInput {
  field: QueryPeopleSortField;
  direction: SortDirection;
}

/** Used to identify a person in input operations */
export interface PersonIdentityInput {
  /** provider */
  provider: PersonIdentityProvider;
  /** identifier of their account */
  key: Scalars['String'];
}

/** Nullable to support delete operations. e.g.: Update my manager to null. */
export interface NullablePersonIdentityInput {
  provider: PersonIdentityProvider;
  key?: InputMaybe<Scalars['String']>;
}

/** Used to identify Departments, Locations, and Groups. */
export type EntityIdentifierType =
  /** client-provided key */
  | 'EXTERNAL'
  /** globally unique, kazoo-generated id */
  | 'KAZOO_ID'
  /** hg */
  | 'LEGACY_HIGHGROUND_ID'
  /** YEI */
  | 'LEGACY_YEI_ID';

/** Identifies an entity like a Location, Group, or Department.  Nullable for use in delete operations like 'set my department to null'. */
export interface NullableEntityIdentifierInput {
  type: EntityIdentifierType;
  key?: InputMaybe<Scalars['String']>;
}

/** Identifies an entity like a Location, Group, or Department. */
export interface EntityIdentifierInput {
  type: EntityIdentifierType;
  key: Scalars['String'];
}

/** creates or updates a person record, typically from HRIS import. */
export interface CreateOrUpdatePersonInput {
  /** client generated id for this update.  Ensures this update succeeds once and only once. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Optional id for correlating bulk operations.  If provided, these are aggregated on the Batch entity. */
  batchId?: InputMaybe<Scalars['String']>;
  /** Optional ordinal value for bulk opertions.  Useful for sorting the results of batch operations. */
  batchSequence?: InputMaybe<Scalars['Int']>;
  /**
   * Identifies the user to be created or updated.
   * Providing a null value for this field will create a new Person, though you _must_
   * provide at least one identity that matches the company identity provider in the
   * `identitiesToAdd` field.
   */
  identifier?: InputMaybe<PersonIdentityInput>;
  /** array of provider/key pairs to add */
  identitiesToAdd?: InputMaybe<Array<PersonIdentityInput>>;
  /** array of provider strings to remove */
  identitiesToRemove?: InputMaybe<Array<PersonIdentityProvider>>;
  /** Most people have a manager. */
  manager?: InputMaybe<NullablePersonIdentityInput>;
  /** Overwrites the existing list of groups with this list.  Empty if [].  No op for null.  Use in place of groupsToAdd/groupsToRemove */
  groups?: InputMaybe<Array<EntityIdentifierInput>>;
  /** These are all group memberships that are not department, title, or location, e.g. 2019 Interns or Team Bravo. */
  groupsToAdd?: InputMaybe<Array<EntityIdentifierInput>>;
  /** These are all group memberships that are not department, title, or location, e.g. 2019 Interns or Team Bravo. */
  groupsToRemove?: InputMaybe<Array<EntityIdentifierInput>>;
  /** Add this person to these security roles */
  rolesToAdd?: InputMaybe<Array<Role>>;
  /** Remove this person from these security roles */
  rolesToRemove?: InputMaybe<Array<Role>>;
  /** Set the roles on this person to these.  Invalid with either rolesToAdd or rolesToRemove. */
  roles?: InputMaybe<Array<Role>>;
  /** e.g. IT_HLP.  If key is null, we remove them from the department. */
  department?: InputMaybe<NullableEntityIdentifierInput>;
  /** This can be as granular as desired. E.g. US, or Chicago, or 363 W Erie.  If key is null, we remove them from the location. */
  location?: InputMaybe<NullableEntityIdentifierInput>;
  /** e.g. Customer Service Representative II. */
  title?: InputMaybe<Scalars['String']>;
  /** Person's name. See NameInput for details. */
  name?: InputMaybe<NameInput>;
  /** Supports firstName and lastName. */
  legacyNameInput?: InputMaybe<LegacyNameInput>;
  /** person's country code. e.g. US, CA, MX, etc. */
  country?: InputMaybe<Scalars['String']>;
  /** If provided, and null, we set the current value to default. */
  avatar?: InputMaybe<ImageInput>;
  /** Employee bio, statement of purpose, shocking facts, pets, etc. */
  aboutMe?: InputMaybe<Scalars['String']>;
  /** ISO 639-1 ISO 3316-1 language code e.g. en-US, es-MX */
  locale?: InputMaybe<Scalars['String']>;
  /** ISO-8601 date only (e.g. YYYY-MM-DDTHH:MM:SSZ). Used for tracking anniversaries. */
  employmentStartDate?: InputMaybe<Scalars['StrictDateTimeInput']>;
  /** month and year only */
  birthday?: InputMaybe<MonthDayInput>;
  /** ISO-8601 date only (e.g. YYYY-MM-DDTHH:MM:SSZ). Updating DOB will also update birthday. */
  dateOfBirth?: InputMaybe<Scalars['StrictDateTimeInput']>;
  /** month and year only */
  workAnniversary?: InputMaybe<MonthDayInput>;
  /**
   * Active or archived.  If null, a no-op
   * Changing the status of someone to ARCHIVE does not delete any of their relationships with any other table/entity
   */
  status?: InputMaybe<PersonStatus>;
  /** person's email */
  email?: InputMaybe<Scalars['String']>;
  /** showBirthday, showAnniversary belong to on user profile */
  profileSettings?: InputMaybe<ProfileSettingsInput>;
  /** Use this field to request directory to perform tasks after the User has been created or Updated. Refer the documentation on each enum values for more details. */
  followupTasks?: InputMaybe<Array<InputMaybe<CrudPersonFollowupTasks>>>;
  /** Person that has access to conditionally review the modules of the users they 'Coach' or 'Manage' */
  secondaryManager?: InputMaybe<NullablePersonIdentityInput>;
  /** If provided, overwrites the existing custom attributes with this list.  To remove an attribute, set 'archiveMissing' to true and only pass the attributes you intend to keep.  Or pass "" for the value. */
  customAttributes?: InputMaybe<CustomAttributeValuesInput>;
  options?: InputMaybe<CreateOrUpdatePersonOptionsInput>;
  /** The people that this person assists. Assistants can take certain actions on behalf of the person they assist. */
  assists?: InputMaybe<Array<PersonIdentityInput>>;
}

export interface CreateOrUpdatePersonOptionsInput {
  /** If true, we do not create a person.  Used in scenarios where we do bulk operations and want to ONLY update. */
  onlyCreateIfStatusIn?: InputMaybe<Array<PersonStatus>>;
  /** Skips adding or changing the manager if the new manager does not exist. */
  skipManagerIfNotFound?: InputMaybe<Scalars['Boolean']>;
  /** Skips adding or changing the secondary manager if the new manager does not exist. */
  skipSecondaryManagerIfNotFound?: InputMaybe<Scalars['Boolean']>;
  /** converts bad email input like ali ce@acme.com to alice@acme.com */
  closeUpSpacesInEmail?: InputMaybe<Scalars['Boolean']>;
  /** If true, it creates/updates the person without the avatar if the avatar service is unavailable. */
  warnOnAvatarProblems?: InputMaybe<Scalars['Boolean']>;
}

export interface CreateOrUpdateDepartmentInput {
  /** client generated id for this update.  Ensures this update succeeds once and only once. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Optional id for correlating bulk operations.  If provided, these are aggregated on the Batch entity. */
  batchId?: InputMaybe<Scalars['String']>;
  /** Optional ordinal value for bulk opertions.  Useful for sorting the results of batch operations. */
  batchSequence?: InputMaybe<Scalars['Int']>;
  /** attempts an insert operation if not provided */
  identifier: EntityIdentifierInput;
  name?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<NullableEntityIdentifierInput>;
  active?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<DepartmentLocationGroupStatus>;
  /** Overwrites the existing list of administrators with this list.  Empty if [].  No op for null. */
  administrators?: InputMaybe<Array<PersonIdentityInput>>;
  /** Adds these administrators. */
  administratorsToAdd?: InputMaybe<Array<PersonIdentityInput>>;
  /** Removes these administrators. */
  administratorsToRemove?: InputMaybe<Array<PersonIdentityInput>>;
  /** Overwrites the existing list of owners with this list.  Empty if [].  No op for null. */
  owners?: InputMaybe<Array<PersonIdentityInput>>;
  /** Adds these owners. */
  ownersToAdd?: InputMaybe<Array<PersonIdentityInput>>;
  /** Removes these owners. */
  ownersToRemove?: InputMaybe<Array<PersonIdentityInput>>;
  legacyRrId?: InputMaybe<Scalars['String']>;
  legacyPmId?: InputMaybe<Scalars['String']>;
}

export interface CreateOrUpdateLocationInput {
  /** client generated id for this update.  Ensures this update succeeds once and only once. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Optional id for correlating bulk operations.  If provided, these are aggregated on the Batch entity. */
  batchId?: InputMaybe<Scalars['String']>;
  /** Optional ordinal value for bulk opertions.  Useful for sorting the results of batch operations. */
  batchSequence?: InputMaybe<Scalars['Int']>;
  /** attempts an insert operation if not provided */
  identifier: EntityIdentifierInput;
  name?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<NullableEntityIdentifierInput>;
  active?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<DepartmentLocationGroupStatus>;
  legacyRrId?: InputMaybe<Scalars['String']>;
  legacyPmId?: InputMaybe<Scalars['String']>;
  /** Overwrites the existing list of administrators with this list.  Empty if [].  No op for null. */
  administrators?: InputMaybe<Array<PersonIdentityInput>>;
  /** Adds these administrators. */
  administratorsToAdd?: InputMaybe<Array<PersonIdentityInput>>;
  /** Removes these administrators. */
  administratorsToRemove?: InputMaybe<Array<PersonIdentityInput>>;
  /** Overwrites the existing list of owners with this list.  Empty if [].  No op for null. */
  owners?: InputMaybe<Array<PersonIdentityInput>>;
  /** Adds these owners. */
  ownersToAdd?: InputMaybe<Array<PersonIdentityInput>>;
  /** Removes these owners. */
  ownersToRemove?: InputMaybe<Array<PersonIdentityInput>>;
}

export interface CreateOrUpdateGroupInput {
  /** client generated id for this update.  Ensures this update succeeds once and only once. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Optional id for correlating bulk operations.  If provided, these are aggregated on the Batch entity. */
  batchId?: InputMaybe<Scalars['String']>;
  /** Optional ordinal value for bulk opertions.  Useful for sorting the results of batch operations. */
  batchSequence?: InputMaybe<Scalars['Int']>;
  /** attempts an insert operation if not provided */
  identifier: EntityIdentifierInput;
  /** legacy platform identifier */
  legacyRrId?: InputMaybe<Scalars['String']>;
  /** YEI group type identifier */
  legacyRrGroupTypeId?: InputMaybe<Scalars['String']>;
  legacyPmId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** Group creation defaults to type AFFINITY. Any change to GroupType cascades to the Group's children. One may not change a child Group's GroupType directly. */
  type?: InputMaybe<GroupType>;
  key?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<NullableEntityIdentifierInput>;
  active?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<DepartmentLocationGroupStatus>;
  /** Overwrites the existing list of administrators with this list.  Empty if [].  No op for null. */
  administrators?: InputMaybe<Array<PersonIdentityInput>>;
  /** Adds these administrators. */
  administratorsToAdd?: InputMaybe<Array<PersonIdentityInput>>;
  /** Removes these administrators. */
  administratorsToRemove?: InputMaybe<Array<PersonIdentityInput>>;
  /** Overwrites the existing list of owners with this list.  Empty if [].  No op for null. */
  owners?: InputMaybe<Array<PersonIdentityInput>>;
  /** Adds these owners. */
  ownersToAdd?: InputMaybe<Array<PersonIdentityInput>>;
  /** Removes these owners. */
  ownersToRemove?: InputMaybe<Array<PersonIdentityInput>>;
}

export type GroupType =
  /** e.g. Intern Class of 2014, front-end developers */
  | 'AFFINITY'
  /** Does not appear for non-admins.  Typically used for things like CostCenter that is meaningless for end users. */
  | 'PRIVATE';

/** Allows us to attach custom attributes to a person */
export interface CustomAttributeValuesInput {
  archiveMissing?: InputMaybe<Scalars['Boolean']>;
  values: Array<CustomAttributeValueInput>;
}

/** name and value of a custom attribute */
export interface CustomAttributeValueInput {
  /** Canonical name of this custom field.  If it doesn't exist, we throw a UserInputError. */
  name: Scalars['String'];
  /**
   * We pass the value in as a string and parse it at runtime.
   * Passing invalid input, e.g. 'foo' for an number field will throw UserInputError.
   * Passing null removes the custom field from the Person.
   */
  value?: InputMaybe<Scalars['String']>;
  /**
   * We do not make DB updates that are no-ops, but for tracking the system activity feature,
   * product would like us to track when we last successfully fetched and attempted to update
   * system attributes, regardless of if the actual data was a no-op.
   */
  syncedFromWarehouseAt?: InputMaybe<Scalars['Date']>;
}

export type CrudPersonFollowupTasks =
  /** Sends email notification once user is activated whether or not they are new. */
  | 'REQUEST_ACCOUNT_ACTIVATION'
  /** Sends email notification once user is activated but only for newly created people. */
  | 'REQUEST_ACCOUNT_ACTIVATION_IF_NEW';

export interface ProfileSettingsInput {
  /** Display birthday on user profile */
  showBirthday?: InputMaybe<Scalars['Boolean']>;
  /** Display start date on user profile */
  showAnniversary?: InputMaybe<Scalars['Boolean']>;
}

export type PersonStatus =
  /** They are an active Kazoo user. */
  | 'ACTIVE'
  /** They have been deleted. */
  | 'ARCHIVED'
  /** They cannot login or be a participant, but their points remain. */
  | 'PAUSED'
  /** records anonymized/deleted for GDPR-type scenarios */
  | 'PURGED';

export type DepartmentLocationGroupStatus =
  | 'ACTIVE'
  /** The department, location, or group has been deleted, but can be resurrected */
  | 'ARCHIVED'
  /** Records deleted and no longer recoverable by users */
  | 'DELETED';

export type ImageInputType =
  | 'BYTES_BASE_64'
  | 'NULLIFY'
  | 'URL';

export interface ImageInput {
  type?: InputMaybe<ImageInputType>;
  payload: Scalars['String'];
  /** Should the software automatically center the user's face? */
  autoFocus?: InputMaybe<Scalars['Boolean']>;
  /** When true, the main Person updates will happen as normal but the avatar upload will happen asynchronously as a task. Only supports URL avatars. For use in batches. */
  performAsync?: InputMaybe<Scalars['Boolean']>;
}

/** Setting any of these to null ignores the input.  Setting to empty string clears it. */
export interface NameInput {
  preferredName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
}

/** Support legacy name concepts. */
export interface LegacyNameInput {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
}

/** These are used when mapping Kazoo Person fields to Pulse. */
export type KazooField =
  | 'COUNTRY'
  | 'DATE_OF_BIRTH'
  | 'DEPARTMENT'
  | 'EMAIL'
  | 'EMPLOYEE_ID'
  | 'EMPLOYMENT_START_DATE'
  | 'FIRST_NAME'
  | 'JOB_TITLE'
  | 'LAST_NAME'
  | 'LOCATION'
  | 'MANAGER'
  | 'PARENT_DEPARTMENT'
  | 'PARENT_LOCATION'
  | 'PREFERRED_NAME';

export interface ArchivePeopleNotInBatchInput {
  batchId: Scalars['String'];
}

/** Only the fields passed through will be updated in the database. */
export interface CreateOrUpdateGoalInput {
  /** ID of the goal to update. */
  id?: InputMaybe<Scalars['ID']>;
  /** User supplied unique key. Immutable */
  externalKey?: InputMaybe<Scalars['String']>;
  /** If provided, associates this update with a batch. */
  batchId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  /** There aren't huge differences in the goal data depending on the type, so it's perfectly fine to change the goal's type on the fly. */
  type?: InputMaybe<GoalType>;
  /** Updates existing measurable results attached to the goal. */
  measurableResults?: InputMaybe<Array<UpdateMeasurableResultFromGoalInput>>;
  riskStatus?: InputMaybe<GoalRiskStatus>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
  /** Defaults to PUBLIC */
  privacy?: InputMaybe<GoalPrivacy>;
  /** ID of the goal this goal aligns to. */
  parentGoalId?: InputMaybe<Scalars['ID']>;
  /** External key of the goal that this goal aligns to.  If parentGoalId is provided, this is ignored. */
  parentGoalExternalKey?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<GoalStatus>;
  /** Reason why the Goal will be closed */
  closeReason?: InputMaybe<Scalars['String']>;
  /** If the Goal will be closed, is it completed? */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** ID of the department to which the Goal will be linked */
  departmentId?: InputMaybe<Scalars['ID']>;
  /** Identifier of the of the department using directory-style inputs.  If departmentId is provided, this is ignored. */
  departmentIdentifier?: InputMaybe<EntityIdentifierInput>;
  /** IDs of the collaborators of the Goal. If this is an empty array, that indicates remove all collaborators. Undefined means no op. */
  collaboratorsIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Identifiers of the of the collaborators using directory-style inputs. If this is an empty array, that indicates remove all collaborators. Undefined means no op. If collaboratorIds is provided, this is ignored. */
  collaboratorsIdentifiers?: InputMaybe<Array<PersonIdentityInput>>;
  /** Owner ID, only updates on Orphaned Goals */
  ownerId?: InputMaybe<Scalars['ID']>;
  /** Identifier of the owner using directory-stlye inputs.  If ownerId is provided, this is ignored. */
  ownerIdentifier?: InputMaybe<PersonIdentityInput>;
  /** ID of category this Goal aligns to. */
  categoryId?: InputMaybe<Scalars['String']>;
  /** Name of the category that this goal aligns to.  If categoryId is provided, this is ignored. */
  categoryName?: InputMaybe<Scalars['String']>;
  /** optional comment */
  comment?: InputMaybe<Scalars['String']>;
}

export interface UpdateMeasurableResultFromGoalInput {
  id?: InputMaybe<Scalars['ID']>;
  target?: InputMaybe<Scalars['Int']>;
  progress?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<MeasurableResultType>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
}

export type MeasurableResultType =
  | 'BOOLEAN'
  | 'NUMERIC'
  | 'PERCENT';

export type GoalType =
  | 'COMPANY'
  | 'DEPARTMENT'
  | 'INDIVIDUAL';

export type GoalStatus =
  | 'AWAITING_APPROVAL'
  | 'AWAITING_CLOSURE'
  | 'CLOSED'
  | 'DRAFT'
  | 'IN_PROGRESS'
  | 'OVERDUE';

export type GoalRiskStatus =
  | 'AT_RISK'
  | 'BEHIND'
  | 'ON_TRACK';

export type GoalPrivacy =
  | 'PRIVATE'
  | 'PUBLIC';

export interface AssignPointRuleInput {
  /**
   * Optional identifier for grouping this operation into a batch.
   *
   * If provided, we will look up the person and if they were created in the same batch, we will apply the point rule (if the point rule is to be applied on new person input).
   */
  batchId?: InputMaybe<Scalars['String']>;
  /** The identifier of the point rule. */
  pointRuleIdentifier: PointRuleIdentifier;
  /** The id of the person. */
  personIdentifier: PersonIdentityInput;
  personOptions?: InputMaybe<PersonPointOperationOptions>;
}

export interface PersonPointOperationOptions {
  /** If the person cannot be found, we suppress the error.  Used in 'do not create inactive people' scenarios. */
  suppressErrorForPersonNotFound?: InputMaybe<Scalars['Boolean']>;
  /** We only ever apply point rules on assignment if we are also creating the person. At this time, its only possible to create and assign a point rule at the same time via batches. The default here is false, and batches will specify true. */
  applyPointRuleOnAssignment?: InputMaybe<Scalars['Boolean']>;
}

export type PointRuleIdentifierType =
  | 'KAZOO_ID'
  /** Legacy YEI ID is to be used only during migrating a company from YEI to KW. */
  | 'LEGACY_YEI_ID'
  | 'NAME';

export interface PointRuleIdentifier {
  type: PointRuleIdentifierType;
  /** If null, we remove the point rule from the person. */
  key?: InputMaybe<Scalars['String']>;
}

export type PointBalanceAccount =
  | 'GIVING'
  | 'REDEMPTION';

export interface PointBalanceInput {
  /** Optional identifier for grouping this operation into a batch. */
  batchId?: InputMaybe<Scalars['String']>;
  /** The owner of the point balance to adjust. */
  personIdentifier: PersonIdentityInput;
  /** A globally unique client key that guarantees the points are adjusted only once. */
  idempotencyKey: Scalars['ID'];
  /** Which user account should be adjusted? */
  account: PointBalanceAccount;
  /** The positive or negative number of points to transact. Only use if absolutely necessary. */
  points: Scalars['Int'];
  /** If true, the operation will be executed synchronously. */
  synchronouslyApplyAdjustment?: InputMaybe<Scalars['Boolean']>;
  /**
   * An event identifier related to the adjustment for audit purposes.
   *
   * Example: `Incentive:Claimed:123`
   */
  eventId: Scalars['String'];
  personOptions?: InputMaybe<PersonPointOperationOptions>;
}

export type PointRuleApplicationReason =
  | 'ADMINISTRATIVE_OVERRIDE'
  | 'PERIODIC_REFRESH'
  | 'PERSON_CREATED';

export interface RefreshPointsInput {
  personId: Scalars['ID'];
  /** If not provided, it executes the built in point rules for the company */
  pointRuleId?: InputMaybe<Scalars['ID']>;
  idempotencyKey: Scalars['String'];
  batchId: Scalars['ID'];
  pointRefreshRunId: Scalars['ID'];
  /** If true, the operation will not actually execute. */
  dryRun?: InputMaybe<Scalars['Boolean']>;
}

export interface RecognitionIdentifierInput {
  id: Scalars['String'];
}

export interface RecipientsSearchOptionsInput {
  namePartial: Scalars['String'];
}

export interface ConfigureRecognitionGiphySettingsInput {
  enabled: Scalars['Boolean'];
  rating?: InputMaybe<GiphyContentRating>;
  defaultSearchTerm?: InputMaybe<Scalars['String']>;
}

export interface CreateOrUpdateRecognitionInput {
  /** The ID of the Recognition for updating. Can be a KW Recognition ID or YEI Recognition ID */
  id?: InputMaybe<Scalars['ID']>;
  /** For robots to send Recognition on behalf of a user. Request will fail for non-robots */
  senderIdentifier?: InputMaybe<RecognitionSenderInput>;
  /** The content of the Recognition. Legacy, only supports plain text. Use richTextBody for rich text content (which allows you to specify the content in any format). */
  body?: InputMaybe<Scalars['String']>;
  /** The content of the Recognition. */
  richTextBody?: InputMaybe<RichTextContentInput>;
  /**
   * If the company is KW_USERS or KW_USERS_READ_ONLY, recipients MUST have be a list of KAZOO_ID identity providers. Otherwise this means
   * they are a YEI-only company and their identity providers must be LEGACY_YEI_ID
   */
  recipients?: InputMaybe<Array<RecipientInput>>;
  /** Core Value is provided as its actual text value rather than ID. It will be looked up by workspace + name */
  coreValueName?: InputMaybe<Scalars['String']>;
  /** Skills are sent as a list of their string names. */
  skills?: InputMaybe<Array<Scalars['String']>>;
  /** Indicates the privacy of the Recognition. */
  public?: Scalars['Boolean'];
  /** Request will fail for companies which force zero-point recognitions */
  points?: InputMaybe<PointsInput>;
  /**
   * Unique ID that prevents a Recognition from being processed more than once. When in doubt, use a UUID."
   * Required for create operations and will be disregarded on edit operations.
   */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** ID of the batch to which this recognition belongs. This is used for bulk recognitions. */
  batchId?: InputMaybe<Scalars['String']>;
  /** The type of recognition to send */
  recognitionType?: InputMaybe<RecognitionType>;
  /** The source of the recognition */
  source?: InputMaybe<RecognitionSource>;
  /** Whether the user accepted the AI writer's recommendation */
  acceptedAIRecommendation?: InputMaybe<Scalars['Boolean']>;
  /** ImageUpload IDs that were uploaded in association with this Recognition. An empty array will remove all images. */
  images?: InputMaybe<Array<Scalars['ID']>>;
}

export interface RecognitionSenderInput {
  provider: RecognitionSenderIdentityProvider;
  key?: InputMaybe<Scalars['String']>;
}

export interface RecipientInput {
  type: RecipientType;
  identifier: RecipientIdentifierInput;
}

export interface RecipientIdentifierInput {
  key: Scalars['String'];
  provider: RecognitionIdentityProvider;
}

export interface PointsInput {
  type: PointsType;
  amount: Scalars['Int'];
  tokenId?: InputMaybe<Scalars['String']>;
  nonTaxable?: InputMaybe<Scalars['Boolean']>;
}

export interface PointsPayload {
  __typename?: 'PointsPayload';
  type: PointsType;
  amount: Scalars['Int'];
  /** For SPECIAL_CATALOG_TOKEN type, the token ID to be used for the recognition */
  tokenId?: Maybe<Scalars['String']>;
  nonTaxable: Scalars['Boolean'];
}

export type RecipientType =
  | 'PERSON';

export type PointsType =
  | 'POINTS'
  | 'SPECIAL_CATALOG_TOKENS';

export type GiphyContentRating =
  | 'G'
  | 'PG'
  | 'PG13';

export type RecognitionIdentityProvider =
  | 'KAZOO_ID'
  | 'LEGACY_YEI_ID';

export type RecognitionPrivacy =
  | 'PRIVATE'
  | 'PUBLIC';

export type RecognitionRole =
  | 'RECIPIENT'
  | 'SENDER';

export type RecognitionType =
  /** A bulk recognition sent to multiple recipients by an admin */
  | 'BULK_RECOGNITION'
  /** An automated birthday or work anniversary recognition sent by the system */
  | 'MILESTONE_RECOGNITION'
  /** A standard peer-to-peer recognition */
  | 'PEER_TO_PEER_RECOGNITION'
  /** An ad-hoc special recognition sent by an admin on behalf of the company */
  | 'SPECIAL_RECOGNITION';

export type RecognitionSenderIdentityProvider =
  | 'KAZOO_ID'
  | 'LEGACY_YEI_ID'
  | 'SYSTEM';

export type RecognitionSource =
  | 'ANDROID'
  | 'IOS'
  | 'SLACK'
  | 'WEB_BULK_RECOGNITION'
  | 'WEB_DASHBOARD'
  | 'WEB_OTHER'
  | 'WEB_PROFILE'
  | 'UPLOAD';

export interface RecognitionEvent {
  __typename?: 'RecognitionEvent';
  /** The ID of the Recognition as it lives in the database */
  aggregateId: Scalars['ID'];
  aggregateType: Scalars['String'];
  type: Scalars['String'];
  timestamp: Scalars['DateTime'];
}

export interface MigrateIncentivesEntityInput {
  /** The type of the legacy entity to migrate */
  type: MigratableIncentivesEntity;
  /** The MongoDB ObjectID of the legacy entity */
  legacyId: Scalars['ID'];
  /** The ID of the IncentivesMigrationBatch that this migration belongs to */
  batchId: Scalars['ID'];
  /** If true, the provided legacy data will not be persisted. */
  dryRun?: Scalars['Boolean'];
}

export type MigratableIncentivesEntity =
  | 'ITEM'
  | 'ITEM_ORDER';

export interface CreateWorkOsUserFromKwPersonInput {
  personId: Scalars['ID'];
  batchId?: InputMaybe<Scalars['String']>;
}

export type AbandonQuestionMutationVariables = Exact<{
  input: AbandonQuestionInput;
}>;


export type AbandonQuestionMutation = { __typename?: 'Mutation', abandonQuestion: { __typename?: 'AbandonQuestionPayload', success: boolean } };

export type AddUserToOrganizationMutationVariables = Exact<{
  input: AddUserToOrganizationInput;
}>;


export type AddUserToOrganizationMutation = { __typename?: 'Mutation', addUserToOrganization: { __typename?: 'AddUserToOrganizationPayload', userOrganization: { __typename?: 'UserOrganization', id: string, role: UserOrganizationRole, user: { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined }, organization: { __typename?: 'Organization', id: string, name: string, createdAt: any, userCount: number } } } };

export type AnswerBooleanQuestionMutationVariables = Exact<{
  input: AnswerBooleanQuestionInput;
}>;


export type AnswerBooleanQuestionMutation = { __typename?: 'Mutation', answerBooleanQuestion: { __typename?: 'AnswerQuestionPayload', answer?: string | undefined, answeredAt?: any | undefined } };

export type AnswerMultipleChoiceQuestionMutationVariables = Exact<{
  input: AnswerMultipleChoiceQuestionInput;
}>;


export type AnswerMultipleChoiceQuestionMutation = { __typename?: 'Mutation', answerMultipleChoiceQuestion: { __typename?: 'AnswerQuestionPayload', answer?: string | undefined, answeredAt?: any | undefined } };

export type AnswerRankingQuestionMutationVariables = Exact<{
  input: AnswerRankingQuestionInput;
}>;


export type AnswerRankingQuestionMutation = { __typename?: 'Mutation', answerRankingQuestion: { __typename?: 'AnswerQuestionPayload', answer?: string | undefined, answeredAt?: any | undefined } };

export type AnswerRatingScaleQuestionMutationVariables = Exact<{
  input: AnswerRatingScaleQuestionInput;
}>;


export type AnswerRatingScaleQuestionMutation = { __typename?: 'Mutation', answerRatingScaleQuestion: { __typename?: 'AnswerQuestionPayload', answer?: string | undefined, answeredAt?: any | undefined } };

export type AnswerSolutionQuestionMutationVariables = Exact<{
  input: AnswerSolutionQuestionInput;
}>;


export type AnswerSolutionQuestionMutation = { __typename?: 'Mutation', answerSolutionQuestion: { __typename?: 'AnswerSolutionQuestionPayload', solutionSessionId: string, questionsAnswered: number, isComplete: boolean, nextQuestion?: { __typename?: 'Question', id: string, content: { __typename?: 'MultipleChoiceQuestionContent' } | { __typename?: 'TextQuestionContent', question: string } | { __typename?: 'BooleanQuestionContent' } | { __typename?: 'RankingQuestionContent' } | { __typename?: 'RatingScaleQuestionContent' } } | undefined } };

export type AnswerTextQuestionMutationVariables = Exact<{
  input: AnswerTextQuestionInput;
}>;


export type AnswerTextQuestionMutation = { __typename?: 'Mutation', answerTextQuestion: { __typename?: 'AnswerQuestionPayload', answer?: string | undefined, answeredAt?: any | undefined } };

export type ArchiveSessionAttributeTemplateMutationVariables = Exact<{
  input: ArchiveSessionAttributeTemplateInput;
}>;


export type ArchiveSessionAttributeTemplateMutation = { __typename?: 'Mutation', archiveSessionAttributeTemplate: { __typename?: 'ArchiveSessionAttributeTemplatePayload', sessionAttributeTemplate: { __typename?: 'SessionAttributeTemplate', id: string, name: string, type: SessionAttributeType, options: Array<string>, archived: boolean, createdAt: any } } };

export type ArchiveUserMutationVariables = Exact<{
  input: ArchiveUserInput;
}>;


export type ArchiveUserMutation = { __typename?: 'Mutation', archiveUser: { __typename?: 'ArchiveUserPayload', user: { __typename?: 'User', id: string, status?: UserStatus | undefined } } };

export type AssignTopicOwnershipMutationVariables = Exact<{
  input: AssignTopicOwnershipInput;
}>;


export type AssignTopicOwnershipMutation = { __typename?: 'Mutation', assignTopicOwnership: { __typename?: 'AssignTopicOwnershipPayload', topicAssignment: { __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }, idea: { __typename?: 'Issue', id: string, topicAssignments: Array<{ __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }> } | { __typename?: 'Opportunity', id: string, topicAssignments: Array<{ __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }> } | { __typename?: 'Praise', id: string, topicAssignments: Array<{ __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }> } } };

export type BubbleGraphDataQueryVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type BubbleGraphDataQuery = { __typename?: 'Query', sessionInsights: { __typename?: 'SessionInsightsResult', sessionInsights?: { __typename?: 'SessionInsights', issues: Array<{ __typename?: 'Issue', id: string, name: string, description: string, summary?: string | undefined, score: number, myVote?: VoteType | undefined }>, opportunities: Array<{ __typename?: 'Opportunity', id: string, name: string, description: string, summary?: string | undefined, score: number, myVote?: VoteType | undefined }>, praise: Array<{ __typename?: 'Praise', id: string, name: string, description: string, summary?: string | undefined, score: number, myVote?: VoteType | undefined }>, implementations: Array<{ __typename?: 'Implementation', id: string, name: string, description: string, summary?: string | undefined, score: number, linkedIssueIds: Array<string>, linkedOpportunityIds: Array<string>, linkedPraiseIds: Array<string>, myVote?: VoteType | undefined }> } | undefined } };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'CreateOrganizationPayload', organization: { __typename?: 'Organization', id: string, name: string } } };

export type CreateSessionMutationVariables = Exact<{
  input: CreateSessionInput;
}>;


export type CreateSessionMutation = { __typename?: 'Mutation', createSession: { __typename?: 'CreateSessionPayload', session?: { __typename?: 'Session', id: string, title: string, type: string, description?: string | undefined, status: SessionStatus, createdAt: any, focus?: string | undefined, defaultQuestions: Array<string>, requireDefaultQuestions: boolean, allowExperimentalFactorQuestions: boolean, identificationMode: IdentificationMode, selectedAttributes: Array<{ __typename?: 'SessionAttributeTemplate', id: string, name: string, type: SessionAttributeType, options: Array<string> }> } | undefined } };

export type CreateSessionAttributeTemplateMutationVariables = Exact<{
  input: CreateSessionAttributeTemplateInput;
}>;


export type CreateSessionAttributeTemplateMutation = { __typename?: 'Mutation', createSessionAttributeTemplate: { __typename?: 'CreateSessionAttributeTemplatePayload', sessionAttributeTemplate: { __typename?: 'SessionAttributeTemplate', id: string, name: string, type: SessionAttributeType, options: Array<string>, archived: boolean, createdAt: any } } };

export type DeleteOrganizationMutationVariables = Exact<{
  input: DeleteOrganizationInput;
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganization: { __typename?: 'DeleteOrganizationPayload', success: boolean } };

export type DuplicateSessionMutationVariables = Exact<{
  input: DuplicateSessionInput;
}>;


export type DuplicateSessionMutation = { __typename?: 'Mutation', duplicateSession: { __typename?: 'DuplicateSessionPayload', session?: { __typename?: 'Session', id: string, title: string, type: string, description?: string | undefined, status: SessionStatus, createdAt: any, focus?: string | undefined, defaultQuestions: Array<string>, requireDefaultQuestions: boolean, length: number } | undefined } };

export type EndSessionMutationVariables = Exact<{
  input: EndSessionInput;
}>;


export type EndSessionMutation = { __typename?: 'Mutation', endSession: { __typename?: 'EndSessionPayload', session?: { __typename?: 'Session', id: string, expiresAt?: any | undefined, status: SessionStatus } | undefined } };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined, isPlatformAdmin?: boolean | undefined, source: string, organizationOverridden?: boolean | undefined, status?: UserStatus | undefined, organization?: { __typename?: 'Organization', id: string, name: string } | undefined, organizationMemberships: Array<{ __typename?: 'UserOrganization', id: string, role: UserOrganizationRole, organization: { __typename?: 'Organization', id: string, name: string } }> } };

export type GetNextSolutionQuestionQueryVariables = Exact<{
  solutionSessionId: Scalars['ID'];
}>;


export type GetNextSolutionQuestionQuery = { __typename?: 'Query', nextSolutionQuestion?: { __typename?: 'Question', id: string, content: { __typename?: 'MultipleChoiceQuestionContent' } | { __typename?: 'TextQuestionContent', question: string } | { __typename?: 'BooleanQuestionContent' } | { __typename?: 'RankingQuestionContent' } | { __typename?: 'RatingScaleQuestionContent' } } | undefined };

export type GetOrganizationUsersQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<OrganizationUsersFilterInput>;
  sort?: InputMaybe<Array<OrganizationUsersSortInput> | OrganizationUsersSortInput>;
}>;


export type GetOrganizationUsersQuery = { __typename?: 'Query', organizationUsers: { __typename?: 'UsersConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | undefined, endCursor?: string | undefined }, edges: Array<{ __typename?: 'UsersEdge', cursor: string, node: { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined, source: string, isPlatformAdmin?: boolean | undefined, status?: UserStatus | undefined, createdAt: any, organizationMemberships: Array<{ __typename?: 'UserOrganization', role: UserOrganizationRole }> } }> } };

export type GetOrganizationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<OrganizationsFilterInput>;
}>;


export type GetOrganizationsQuery = { __typename?: 'Query', organizations: { __typename?: 'OrganizationsConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number, hasNextPage: boolean }, edges: Array<{ __typename?: 'OrganizationsEdge', cursor: string, node: { __typename?: 'Organization', id: string, name: string, createdAt: any, userCount: number } }> } };

export type GetParticipantQueryVariables = Exact<{
  sessionId: Scalars['ID'];
  participantId: Scalars['ID'];
}>;


export type GetParticipantQuery = { __typename?: 'Query', participant?: { __typename?: 'Participant', id: string, name: string, title: string } | undefined };

export type GetParticipantAnswersQueryVariables = Exact<{
  sessionId: Scalars['ID'];
  participantId: Scalars['String'];
}>;


export type GetParticipantAnswersQuery = { __typename?: 'Query', participantAnswers: Array<{ __typename?: 'Question', id: string, answer?: string | undefined, answeredAt?: any | undefined, content: { __typename?: 'MultipleChoiceQuestionContent', question: string, multipleChoiceOptions: Array<string> } | { __typename?: 'TextQuestionContent', question: string } | { __typename?: 'BooleanQuestionContent', question: string } | { __typename?: 'RankingQuestionContent', question: string } | { __typename?: 'RatingScaleQuestionContent', question: string } }> };

export type GetParticipantFactorScoresQueryVariables = Exact<{
  sessionId: Scalars['ID'];
  participantId: Scalars['ID'];
}>;


export type GetParticipantFactorScoresQuery = { __typename?: 'Query', participant?: { __typename?: 'Participant', id: string, name: string, title: string, factorScores: Array<{ __typename?: 'ParticipantFactorScore', id: string, factorCode: string, factorName: string, sentiment: FactorSentiment, sentimentLabel: string, summary?: string | undefined }> } | undefined };

export type GetQuestionsQueryVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type GetQuestionsQuery = { __typename?: 'Query', questions: Array<{ __typename?: 'Question', id: string, createdAt: any, content: { __typename?: 'MultipleChoiceQuestionContent', question: string, multipleChoiceOptions: Array<string> } | { __typename?: 'TextQuestionContent', question: string } | { __typename?: 'BooleanQuestionContent', question: string } | { __typename?: 'RankingQuestionContent' } | { __typename?: 'RatingScaleQuestionContent', preamble?: string | undefined, question: string, scaleType: RatingScaleType, minLabel: string, maxLabel: string } }> };

export type GetSessionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetSessionQuery = { __typename?: 'Query', session: { __typename?: 'Session', id: string, title: string, description?: string | undefined, status: SessionStatus, expiresAt?: any | undefined, startedAt?: any | undefined, sessionTimeRemaining?: number | undefined, sectionTimeRemaining?: number | undefined, length: number, section?: SessionSectionType | undefined, createdAt: any, type: string, focus?: string | undefined, defaultQuestions: Array<string>, requireDefaultQuestions: boolean, allowExperimentalFactorQuestions: boolean, identificationMode: IdentificationMode, currentParticipantHasJoined: boolean, selectedAttributes: Array<{ __typename?: 'SessionAttributeTemplate', id: string, name: string, type: SessionAttributeType, options: Array<string> }>, sections: Array<{ __typename?: 'SessionSection', name: string, description?: string | undefined, section: SessionSectionType, timeInSeconds: number, timeRemaining?: number | undefined }>, user: { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined } } };

export type GetSessionAttributeTemplatesQueryVariables = Exact<{
  filter?: InputMaybe<SessionAttributeTemplatesFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetSessionAttributeTemplatesQuery = { __typename?: 'Query', sessionAttributeTemplates: { __typename?: 'SessionAttributeTemplatesConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, totalCount: number }, edges: Array<{ __typename?: 'SessionAttributeTemplatesEdge', cursor: string, node: { __typename?: 'SessionAttributeTemplate', id: string, name: string, type: SessionAttributeType, options: Array<string>, archived: boolean, createdAt: any } }> } };

export type GetSessionFactorsQueryVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type GetSessionFactorsQuery = { __typename?: 'Query', session: { __typename?: 'Session', id: string, factors?: { __typename?: 'SessionFactors', status: SessionFactorGenerationStatus, error?: string | undefined, factors: Array<{ __typename?: 'SessionFactor', id: string, factorCode: string, factorName: string, description: string, analysis: string, quotes: Array<{ __typename?: 'SessionFactorQuote', quote: string, participant: { __typename?: 'Participant', id: string, name: string, title: string } }> }> } | undefined } };

export type GetSessionFeedbackQueryVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type GetSessionFeedbackQuery = { __typename?: 'Query', session: { __typename?: 'Session', id: string, title: string, createdAt: any, feedback: { __typename?: 'FeedbackConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number }, edges: Array<{ __typename?: 'FeedbackEdge', cursor: string, node: { __typename?: 'Feedback', id: string, feedback: string, rating?: number | undefined, createdAt: any, participant: { __typename?: 'Participant', id: string, name: string } } }> } } };

export type GetSessionInsightsQueryVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type GetSessionInsightsQuery = { __typename?: 'Query', sessionInsights: { __typename?: 'SessionInsightsResult', sessionInsights?: { __typename?: 'SessionInsights', participantCount: number, duration: number, sessionSummary?: { __typename?: 'SessionSummary', id: string, positiveHighlights: Array<string>, areasForImprovement: Array<string> } | undefined, issues: Array<{ __typename?: 'Issue', id: string, name: string, description: string, summary?: string | undefined, score: number, topicAssignments: Array<{ __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }> }>, opportunities: Array<{ __typename?: 'Opportunity', id: string, name: string, description: string, summary?: string | undefined, score: number, topicAssignments: Array<{ __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }> }>, praise: Array<{ __typename?: 'Praise', id: string, name: string, description: string, summary?: string | undefined, score: number, topicAssignments: Array<{ __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }> }>, implementations: Array<{ __typename?: 'Implementation', id: string, name: string, description: string, summary?: string | undefined, score: number, linkedIssueIds: Array<string>, linkedOpportunityIds: Array<string> }> } | undefined } };

export type GetSessionLogsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetSessionLogsQuery = { __typename?: 'Query', session: { __typename?: 'Session', id: string, logs: Array<{ __typename?: 'SessionLog', id: string, sessionId: string, level: string, data: string, createdAt: any }> } };

export type GetSessionParticipantsQueryVariables = Exact<{
  sessionId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<ParticipantsSortInput> | ParticipantsSortInput>;
  filter?: InputMaybe<SessionParticipantsFilterInput>;
}>;


export type GetSessionParticipantsQuery = { __typename?: 'Query', session: { __typename?: 'Session', id: string, participants: { __typename?: 'ParticipantsConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | undefined, endCursor?: string | undefined, totalCount: number }, edges: Array<{ __typename?: 'ParticipantsEdge', cursor: string, node: { __typename?: 'Participant', id: string, name: string, title: string, email?: string | undefined, attributeResponses: Array<{ __typename?: 'ParticipantAttributeResponse', value: string, attributeTemplate: { __typename?: 'SessionAttributeTemplate', id: string, name: string } }>, factorScores: Array<{ __typename?: 'ParticipantFactorScore', id: string }> } }> } } };

export type GetSessionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SessionsFilterInput>;
  sort?: InputMaybe<Array<SessionsSortInput> | SessionsSortInput>;
}>;


export type GetSessionsQuery = { __typename?: 'Query', sessions: { __typename?: 'SessionsConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | undefined, endCursor?: string | undefined }, edges: Array<{ __typename?: 'SessionsEdge', cursor: string, node: { __typename?: 'Session', id: string, title: string, status: SessionStatus, createdAt: any, user: { __typename?: 'User', id: string, firstName?: string | undefined, lastName?: string | undefined }, participants: { __typename?: 'ParticipantsConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number } }, feedback: { __typename?: 'FeedbackConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number } } } }> } };

export type GetUserOrganizationsQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type GetUserOrganizationsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, organizationMemberships: Array<{ __typename?: 'UserOrganization', id: string, role: UserOrganizationRole, user: { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined }, organization: { __typename?: 'Organization', id: string, name: string, createdAt: any, userCount: number } }> } };

export type GetUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UsersFilterInput>;
  sort?: InputMaybe<Array<UsersSortInput> | UsersSortInput>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | undefined, endCursor?: string | undefined }, edges: Array<{ __typename?: 'UsersEdge', cursor: string, node: { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined, source: string, isPlatformAdmin?: boolean | undefined, status?: UserStatus | undefined, createdAt: any } }> } };

export type JoinSessionMutationVariables = Exact<{
  input: JoinSessionInput;
}>;


export type JoinSessionMutation = { __typename?: 'Mutation', joinSession: { __typename?: 'JoinSessionPayload', session: { __typename?: 'Session', id: string, currentParticipantHasJoined: boolean }, participant?: { __typename?: 'Participant', id: string, name: string, title: string, email?: string | undefined } | undefined } };

export type NextQuestionQueryVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type NextQuestionQuery = { __typename?: 'Query', nextQuestion: { __typename?: 'NextQuestionResponse', session: { __typename?: 'Session', id: string, type: string, status: SessionStatus, section?: SessionSectionType | undefined, title: string, currentParticipantHasJoined: boolean, sections: Array<{ __typename?: 'SessionSection', name: string, description?: string | undefined, section: SessionSectionType, timeInSeconds: number, timeRemaining?: number | undefined }>, user: { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined } }, question?: { __typename?: 'Question', id: string, createdAt: any, section: SessionSectionType, issues: Array<{ __typename?: 'Issue', id: string, name: string, description: string }>, opportunities: Array<{ __typename?: 'Opportunity', id: string, name: string, description: string }>, implementations: Array<{ __typename?: 'Implementation', id: string, name: string, description: string }>, content: { __typename?: 'MultipleChoiceQuestionContent', preamble?: string | undefined, question: string, multipleChoiceOptions: Array<string> } | { __typename?: 'TextQuestionContent', preamble?: string | undefined, question: string } | { __typename?: 'BooleanQuestionContent', preamble?: string | undefined, question: string } | { __typename?: 'RankingQuestionContent', preamble?: string | undefined, question: string, rankingType?: string | undefined, issues: Array<{ __typename?: 'Issue', id: string, name: string, description: string }>, opportunities: Array<{ __typename?: 'Opportunity', id: string, name: string, description: string }>, rankingOptions: Array<{ __typename?: 'RankingQuestionOption', id: string, text: string, description?: string | undefined }> } | { __typename?: 'RatingScaleQuestionContent', preamble?: string | undefined, question: string, scaleType: RatingScaleType, minLabel: string, maxLabel: string } } | undefined } };

export type PauseSessionMutationVariables = Exact<{
  input: PauseSessionInput;
}>;


export type PauseSessionMutation = { __typename?: 'Mutation', pauseSession: { __typename?: 'PauseSessionPayload', session: { __typename?: 'Session', id: string, status: SessionStatus, user: { __typename?: 'User', id: string } } } };

export type RegenerateSessionSummaryMutationVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type RegenerateSessionSummaryMutation = { __typename?: 'Mutation', regenerateSessionSummary: { __typename?: 'RegenerateSessionSummaryPayload', success: boolean } };

export type RemoveTopicAssignmentMutationVariables = Exact<{
  input: RemoveTopicAssignmentInput;
}>;


export type RemoveTopicAssignmentMutation = { __typename?: 'Mutation', removeTopicAssignment: { __typename?: 'RemoveTopicAssignmentPayload', success: boolean, idea?: { __typename?: 'Issue', id: string, topicAssignments: Array<{ __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }> } | { __typename?: 'Opportunity', id: string, topicAssignments: Array<{ __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }> } | { __typename?: 'Praise', id: string, topicAssignments: Array<{ __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }> } | undefined } };

export type RemoveUserFromOrganizationMutationVariables = Exact<{
  input: RemoveUserFromOrganizationInput;
}>;


export type RemoveUserFromOrganizationMutation = { __typename?: 'Mutation', removeUserFromOrganization: { __typename?: 'RemoveUserFromOrganizationPayload', success: boolean } };

export type ResumeSessionMutationVariables = Exact<{
  input: ResumeSessionInput;
}>;


export type ResumeSessionMutation = { __typename?: 'Mutation', resumeSession: { __typename?: 'ResumeSessionPayload', session: { __typename?: 'Session', id: string, status: SessionStatus, user: { __typename?: 'User', id: string } } } };

export type SaveVoteMutationVariables = Exact<{
  input: SaveVoteInput;
}>;


export type SaveVoteMutation = { __typename?: 'Mutation', saveVote: { __typename?: 'SaveVotePayload', success: boolean, opportunity?: { __typename?: 'Opportunity', id: string, myVote?: VoteType | undefined, score: number } | undefined, implementation?: { __typename?: 'Implementation', id: string, myVote?: VoteType | undefined, score: number } | undefined, issue?: { __typename?: 'Issue', id: string, myVote?: VoteType | undefined, score: number } | undefined } };

export type SendInsightsEmailMutationVariables = Exact<{
  input: SendInsightsEmailInput;
}>;


export type SendInsightsEmailMutation = { __typename?: 'Mutation', sendInsightsEmail: { __typename?: 'SendInsightsEmailPayload', success: boolean, emailsSent: number } };

export type SendInvitationMutationVariables = Exact<{
  input: SendInvitationInput;
}>;


export type SendInvitationMutation = { __typename?: 'Mutation', sendInvitation: { __typename?: 'SendInvitationPayload', invitationSent: boolean, error?: string | undefined, success?: string | undefined } };

export type SkipQuestionMutationVariables = Exact<{
  input: SkipQuestionInput;
}>;


export type SkipQuestionMutation = { __typename?: 'Mutation', skipQuestion: { __typename?: 'AnswerQuestionPayload', answer?: string | undefined, answeredAt?: any | undefined } };

export type SkipToNextSectionMutationVariables = Exact<{
  input: SkipToNextSectionInput;
}>;


export type SkipToNextSectionMutation = { __typename?: 'Mutation', skipToNextSection: { __typename?: 'SkipToNextSectionPayload', newSectionIndex: number, session: { __typename?: 'Session', id: string, sections: Array<{ __typename?: 'SessionSection', section: SessionSectionType, timeRemaining?: number | undefined }> } } };

export type StartSessionMutationVariables = Exact<{
  input: StartSessionInput;
}>;


export type StartSessionMutation = { __typename?: 'Mutation', startSession: { __typename?: 'StartSessionPayload', expiresAt?: any | undefined } };

export type StartSolutionForIdeaMutationVariables = Exact<{
  input: StartSolutionForIdeaInput;
}>;


export type StartSolutionForIdeaMutation = { __typename?: 'Mutation', startSolutionForIdea: { __typename?: 'StartSolutionForIdeaPayload', solutionSessionId: string, nextQuestion?: { __typename?: 'Question', id: string, content: { __typename?: 'MultipleChoiceQuestionContent' } | { __typename?: 'TextQuestionContent', question: string } | { __typename?: 'BooleanQuestionContent' } | { __typename?: 'RankingQuestionContent' } | { __typename?: 'RatingScaleQuestionContent' } } | undefined } };

export type ToggleCurrentUserPlatformAdminMutationVariables = Exact<{ [key: string]: never; }>;


export type ToggleCurrentUserPlatformAdminMutation = { __typename?: 'Mutation', toggleCurrentUserPlatformAdmin: { __typename?: 'ToggleCurrentUserPlatformAdminPayload', user: { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined, isPlatformAdmin?: boolean | undefined, source: string } } };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'UpdateOrganizationPayload', organization: { __typename?: 'Organization', id: string, name: string } } };

export type UpdateSessionMutationVariables = Exact<{
  input: UpdateSessionInput;
}>;


export type UpdateSessionMutation = { __typename?: 'Mutation', updateSession: { __typename?: 'UpdateSessionPayload', session?: { __typename?: 'Session', id: string, title: string, type: string, description?: string | undefined, status: SessionStatus, createdAt: any, focus?: string | undefined, defaultQuestions: Array<string>, requireDefaultQuestions: boolean, allowExperimentalFactorQuestions: boolean, identificationMode: IdentificationMode, selectedAttributes: Array<{ __typename?: 'SessionAttributeTemplate', id: string, name: string, type: SessionAttributeType, options: Array<string> }> } | undefined } };

export type UpdateSessionAttributeTemplateMutationVariables = Exact<{
  input: UpdateSessionAttributeTemplateInput;
}>;


export type UpdateSessionAttributeTemplateMutation = { __typename?: 'Mutation', updateSessionAttributeTemplate: { __typename?: 'UpdateSessionAttributeTemplatePayload', sessionAttributeTemplate: { __typename?: 'SessionAttributeTemplate', id: string, name: string, type: SessionAttributeType, options: Array<string>, archived: boolean, createdAt: any } } };

export type UpdateUserOrganizationRoleMutationVariables = Exact<{
  input: UpdateUserOrganizationRoleInput;
}>;


export type UpdateUserOrganizationRoleMutation = { __typename?: 'Mutation', updateUserOrganizationRole: { __typename?: 'UpdateUserOrganizationRolePayload', userOrganization: { __typename?: 'UserOrganization', id: string, role: UserOrganizationRole, user: { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined }, organization: { __typename?: 'Organization', id: string, name: string, createdAt: any, userCount: number } } } };

export type SendFeedbackMutationVariables = Exact<{
  input: CreateFeedbackInput;
}>;


export type SendFeedbackMutation = { __typename?: 'Mutation', createFeedback: { __typename?: 'CreateFeedbackPayload', feedback?: { __typename?: 'Feedback', id: string, feedback: string, rating?: number | undefined, participant: { __typename?: 'Participant', id: string, name: string } } | undefined } };


export const AbandonQuestionDocument = gql`
    mutation AbandonQuestion($input: AbandonQuestionInput!) {
  abandonQuestion(input: $input) {
    success
  }
}
    `;
export type AbandonQuestionMutationFn = ApolloReactCommon.MutationFunction<AbandonQuestionMutation, AbandonQuestionMutationVariables>;

/**
 * __useAbandonQuestionMutation__
 *
 * To run a mutation, you first call `useAbandonQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbandonQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abandonQuestionMutation, { data, loading, error }] = useAbandonQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAbandonQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AbandonQuestionMutation, AbandonQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AbandonQuestionMutation, AbandonQuestionMutationVariables>(AbandonQuestionDocument, options);
      }
export type AbandonQuestionMutationHookResult = ReturnType<typeof useAbandonQuestionMutation>;
export type AbandonQuestionMutationResult = ApolloReactCommon.MutationResult<AbandonQuestionMutation>;
export type AbandonQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<AbandonQuestionMutation, AbandonQuestionMutationVariables>;
export const AddUserToOrganizationDocument = gql`
    mutation AddUserToOrganization($input: AddUserToOrganizationInput!) {
  addUserToOrganization(input: $input) {
    userOrganization {
      id
      user {
        id
        email
        firstName
        lastName
      }
      organization {
        id
        name
        createdAt
        userCount
      }
      role
    }
  }
}
    `;
export type AddUserToOrganizationMutationFn = ApolloReactCommon.MutationFunction<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>;

/**
 * __useAddUserToOrganizationMutation__
 *
 * To run a mutation, you first call `useAddUserToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToOrganizationMutation, { data, loading, error }] = useAddUserToOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserToOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>(AddUserToOrganizationDocument, options);
      }
export type AddUserToOrganizationMutationHookResult = ReturnType<typeof useAddUserToOrganizationMutation>;
export type AddUserToOrganizationMutationResult = ApolloReactCommon.MutationResult<AddUserToOrganizationMutation>;
export type AddUserToOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>;
export const AnswerBooleanQuestionDocument = gql`
    mutation AnswerBooleanQuestion($input: AnswerBooleanQuestionInput!) {
  answerBooleanQuestion(input: $input) {
    answer
    answeredAt
  }
}
    `;
export type AnswerBooleanQuestionMutationFn = ApolloReactCommon.MutationFunction<AnswerBooleanQuestionMutation, AnswerBooleanQuestionMutationVariables>;

/**
 * __useAnswerBooleanQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerBooleanQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerBooleanQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerBooleanQuestionMutation, { data, loading, error }] = useAnswerBooleanQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerBooleanQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AnswerBooleanQuestionMutation, AnswerBooleanQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AnswerBooleanQuestionMutation, AnswerBooleanQuestionMutationVariables>(AnswerBooleanQuestionDocument, options);
      }
export type AnswerBooleanQuestionMutationHookResult = ReturnType<typeof useAnswerBooleanQuestionMutation>;
export type AnswerBooleanQuestionMutationResult = ApolloReactCommon.MutationResult<AnswerBooleanQuestionMutation>;
export type AnswerBooleanQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<AnswerBooleanQuestionMutation, AnswerBooleanQuestionMutationVariables>;
export const AnswerMultipleChoiceQuestionDocument = gql`
    mutation AnswerMultipleChoiceQuestion($input: AnswerMultipleChoiceQuestionInput!) {
  answerMultipleChoiceQuestion(input: $input) {
    answer
    answeredAt
  }
}
    `;
export type AnswerMultipleChoiceQuestionMutationFn = ApolloReactCommon.MutationFunction<AnswerMultipleChoiceQuestionMutation, AnswerMultipleChoiceQuestionMutationVariables>;

/**
 * __useAnswerMultipleChoiceQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerMultipleChoiceQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerMultipleChoiceQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerMultipleChoiceQuestionMutation, { data, loading, error }] = useAnswerMultipleChoiceQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerMultipleChoiceQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AnswerMultipleChoiceQuestionMutation, AnswerMultipleChoiceQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AnswerMultipleChoiceQuestionMutation, AnswerMultipleChoiceQuestionMutationVariables>(AnswerMultipleChoiceQuestionDocument, options);
      }
export type AnswerMultipleChoiceQuestionMutationHookResult = ReturnType<typeof useAnswerMultipleChoiceQuestionMutation>;
export type AnswerMultipleChoiceQuestionMutationResult = ApolloReactCommon.MutationResult<AnswerMultipleChoiceQuestionMutation>;
export type AnswerMultipleChoiceQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<AnswerMultipleChoiceQuestionMutation, AnswerMultipleChoiceQuestionMutationVariables>;
export const AnswerRankingQuestionDocument = gql`
    mutation AnswerRankingQuestion($input: AnswerRankingQuestionInput!) {
  answerRankingQuestion(input: $input) {
    answer
    answeredAt
  }
}
    `;
export type AnswerRankingQuestionMutationFn = ApolloReactCommon.MutationFunction<AnswerRankingQuestionMutation, AnswerRankingQuestionMutationVariables>;

/**
 * __useAnswerRankingQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerRankingQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerRankingQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerRankingQuestionMutation, { data, loading, error }] = useAnswerRankingQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerRankingQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AnswerRankingQuestionMutation, AnswerRankingQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AnswerRankingQuestionMutation, AnswerRankingQuestionMutationVariables>(AnswerRankingQuestionDocument, options);
      }
export type AnswerRankingQuestionMutationHookResult = ReturnType<typeof useAnswerRankingQuestionMutation>;
export type AnswerRankingQuestionMutationResult = ApolloReactCommon.MutationResult<AnswerRankingQuestionMutation>;
export type AnswerRankingQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<AnswerRankingQuestionMutation, AnswerRankingQuestionMutationVariables>;
export const AnswerRatingScaleQuestionDocument = gql`
    mutation AnswerRatingScaleQuestion($input: AnswerRatingScaleQuestionInput!) {
  answerRatingScaleQuestion(input: $input) {
    answer
    answeredAt
  }
}
    `;
export type AnswerRatingScaleQuestionMutationFn = ApolloReactCommon.MutationFunction<AnswerRatingScaleQuestionMutation, AnswerRatingScaleQuestionMutationVariables>;

/**
 * __useAnswerRatingScaleQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerRatingScaleQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerRatingScaleQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerRatingScaleQuestionMutation, { data, loading, error }] = useAnswerRatingScaleQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerRatingScaleQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AnswerRatingScaleQuestionMutation, AnswerRatingScaleQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AnswerRatingScaleQuestionMutation, AnswerRatingScaleQuestionMutationVariables>(AnswerRatingScaleQuestionDocument, options);
      }
export type AnswerRatingScaleQuestionMutationHookResult = ReturnType<typeof useAnswerRatingScaleQuestionMutation>;
export type AnswerRatingScaleQuestionMutationResult = ApolloReactCommon.MutationResult<AnswerRatingScaleQuestionMutation>;
export type AnswerRatingScaleQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<AnswerRatingScaleQuestionMutation, AnswerRatingScaleQuestionMutationVariables>;
export const AnswerSolutionQuestionDocument = gql`
    mutation AnswerSolutionQuestion($input: AnswerSolutionQuestionInput!) {
  answerSolutionQuestion(input: $input) {
    solutionSessionId
    questionsAnswered
    isComplete
    nextQuestion {
      id
      content {
        ... on TextQuestionContent {
          question
        }
      }
    }
  }
}
    `;
export type AnswerSolutionQuestionMutationFn = ApolloReactCommon.MutationFunction<AnswerSolutionQuestionMutation, AnswerSolutionQuestionMutationVariables>;

/**
 * __useAnswerSolutionQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerSolutionQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerSolutionQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerSolutionQuestionMutation, { data, loading, error }] = useAnswerSolutionQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerSolutionQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AnswerSolutionQuestionMutation, AnswerSolutionQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AnswerSolutionQuestionMutation, AnswerSolutionQuestionMutationVariables>(AnswerSolutionQuestionDocument, options);
      }
export type AnswerSolutionQuestionMutationHookResult = ReturnType<typeof useAnswerSolutionQuestionMutation>;
export type AnswerSolutionQuestionMutationResult = ApolloReactCommon.MutationResult<AnswerSolutionQuestionMutation>;
export type AnswerSolutionQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<AnswerSolutionQuestionMutation, AnswerSolutionQuestionMutationVariables>;
export const AnswerTextQuestionDocument = gql`
    mutation AnswerTextQuestion($input: AnswerTextQuestionInput!) {
  answerTextQuestion(input: $input) {
    answer
    answeredAt
  }
}
    `;
export type AnswerTextQuestionMutationFn = ApolloReactCommon.MutationFunction<AnswerTextQuestionMutation, AnswerTextQuestionMutationVariables>;

/**
 * __useAnswerTextQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerTextQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerTextQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerTextQuestionMutation, { data, loading, error }] = useAnswerTextQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerTextQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AnswerTextQuestionMutation, AnswerTextQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AnswerTextQuestionMutation, AnswerTextQuestionMutationVariables>(AnswerTextQuestionDocument, options);
      }
export type AnswerTextQuestionMutationHookResult = ReturnType<typeof useAnswerTextQuestionMutation>;
export type AnswerTextQuestionMutationResult = ApolloReactCommon.MutationResult<AnswerTextQuestionMutation>;
export type AnswerTextQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<AnswerTextQuestionMutation, AnswerTextQuestionMutationVariables>;
export const ArchiveSessionAttributeTemplateDocument = gql`
    mutation ArchiveSessionAttributeTemplate($input: ArchiveSessionAttributeTemplateInput!) {
  archiveSessionAttributeTemplate(input: $input) {
    sessionAttributeTemplate {
      id
      name
      type
      options
      archived
      createdAt
    }
  }
}
    `;
export type ArchiveSessionAttributeTemplateMutationFn = ApolloReactCommon.MutationFunction<ArchiveSessionAttributeTemplateMutation, ArchiveSessionAttributeTemplateMutationVariables>;

/**
 * __useArchiveSessionAttributeTemplateMutation__
 *
 * To run a mutation, you first call `useArchiveSessionAttributeTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveSessionAttributeTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveSessionAttributeTemplateMutation, { data, loading, error }] = useArchiveSessionAttributeTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveSessionAttributeTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveSessionAttributeTemplateMutation, ArchiveSessionAttributeTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveSessionAttributeTemplateMutation, ArchiveSessionAttributeTemplateMutationVariables>(ArchiveSessionAttributeTemplateDocument, options);
      }
export type ArchiveSessionAttributeTemplateMutationHookResult = ReturnType<typeof useArchiveSessionAttributeTemplateMutation>;
export type ArchiveSessionAttributeTemplateMutationResult = ApolloReactCommon.MutationResult<ArchiveSessionAttributeTemplateMutation>;
export type ArchiveSessionAttributeTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveSessionAttributeTemplateMutation, ArchiveSessionAttributeTemplateMutationVariables>;
export const ArchiveUserDocument = gql`
    mutation ArchiveUser($input: ArchiveUserInput!) {
  archiveUser(input: $input) {
    user {
      id
      status
    }
  }
}
    `;
export type ArchiveUserMutationFn = ApolloReactCommon.MutationFunction<ArchiveUserMutation, ArchiveUserMutationVariables>;

/**
 * __useArchiveUserMutation__
 *
 * To run a mutation, you first call `useArchiveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveUserMutation, { data, loading, error }] = useArchiveUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveUserMutation, ArchiveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveUserMutation, ArchiveUserMutationVariables>(ArchiveUserDocument, options);
      }
export type ArchiveUserMutationHookResult = ReturnType<typeof useArchiveUserMutation>;
export type ArchiveUserMutationResult = ApolloReactCommon.MutationResult<ArchiveUserMutation>;
export type ArchiveUserMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveUserMutation, ArchiveUserMutationVariables>;
export const AssignTopicOwnershipDocument = gql`
    mutation AssignTopicOwnership($input: AssignTopicOwnershipInput!) {
  assignTopicOwnership(input: $input) {
    topicAssignment {
      id
      email
      createdAt
    }
    idea {
      ... on Issue {
        id
        topicAssignments {
          id
          email
          createdAt
        }
      }
      ... on Opportunity {
        id
        topicAssignments {
          id
          email
          createdAt
        }
      }
      ... on Praise {
        id
        topicAssignments {
          id
          email
          createdAt
        }
      }
    }
  }
}
    `;
export type AssignTopicOwnershipMutationFn = ApolloReactCommon.MutationFunction<AssignTopicOwnershipMutation, AssignTopicOwnershipMutationVariables>;

/**
 * __useAssignTopicOwnershipMutation__
 *
 * To run a mutation, you first call `useAssignTopicOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTopicOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTopicOwnershipMutation, { data, loading, error }] = useAssignTopicOwnershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignTopicOwnershipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignTopicOwnershipMutation, AssignTopicOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssignTopicOwnershipMutation, AssignTopicOwnershipMutationVariables>(AssignTopicOwnershipDocument, options);
      }
export type AssignTopicOwnershipMutationHookResult = ReturnType<typeof useAssignTopicOwnershipMutation>;
export type AssignTopicOwnershipMutationResult = ApolloReactCommon.MutationResult<AssignTopicOwnershipMutation>;
export type AssignTopicOwnershipMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignTopicOwnershipMutation, AssignTopicOwnershipMutationVariables>;
export const BubbleGraphDataDocument = gql`
    query BubbleGraphData($sessionId: ID!) {
  sessionInsights(sessionId: $sessionId) {
    sessionInsights {
      issues {
        id
        name
        description
        summary
        score
        myVote
      }
      opportunities {
        id
        name
        description
        summary
        score
        myVote
      }
      praise {
        id
        name
        description
        summary
        score
        myVote
      }
      implementations {
        id
        name
        description
        summary
        score
        linkedIssueIds
        linkedOpportunityIds
        linkedPraiseIds
        myVote
      }
    }
  }
}
    `;

/**
 * __useBubbleGraphDataQuery__
 *
 * To run a query within a React component, call `useBubbleGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBubbleGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBubbleGraphDataQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useBubbleGraphDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BubbleGraphDataQuery, BubbleGraphDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BubbleGraphDataQuery, BubbleGraphDataQueryVariables>(BubbleGraphDataDocument, options);
      }
export function useBubbleGraphDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BubbleGraphDataQuery, BubbleGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BubbleGraphDataQuery, BubbleGraphDataQueryVariables>(BubbleGraphDataDocument, options);
        }
export type BubbleGraphDataQueryHookResult = ReturnType<typeof useBubbleGraphDataQuery>;
export type BubbleGraphDataLazyQueryHookResult = ReturnType<typeof useBubbleGraphDataLazyQuery>;
export type BubbleGraphDataQueryResult = ApolloReactCommon.QueryResult<BubbleGraphDataQuery, BubbleGraphDataQueryVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    organization {
      id
      name
    }
  }
}
    `;
export type CreateOrganizationMutationFn = ApolloReactCommon.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = ApolloReactCommon.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const CreateSessionDocument = gql`
    mutation CreateSession($input: CreateSessionInput!) {
  createSession(input: $input) {
    session {
      id
      title
      type
      description
      status
      createdAt
      focus
      defaultQuestions
      requireDefaultQuestions
      allowExperimentalFactorQuestions
      identificationMode
      selectedAttributes {
        id
        name
        type
        options
      }
    }
  }
}
    `;
export type CreateSessionMutationFn = ApolloReactCommon.MutationFunction<CreateSessionMutation, CreateSessionMutationVariables>;

/**
 * __useCreateSessionMutation__
 *
 * To run a mutation, you first call `useCreateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSessionMutation, { data, loading, error }] = useCreateSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSessionMutation, CreateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSessionMutation, CreateSessionMutationVariables>(CreateSessionDocument, options);
      }
export type CreateSessionMutationHookResult = ReturnType<typeof useCreateSessionMutation>;
export type CreateSessionMutationResult = ApolloReactCommon.MutationResult<CreateSessionMutation>;
export type CreateSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSessionMutation, CreateSessionMutationVariables>;
export const CreateSessionAttributeTemplateDocument = gql`
    mutation CreateSessionAttributeTemplate($input: CreateSessionAttributeTemplateInput!) {
  createSessionAttributeTemplate(input: $input) {
    sessionAttributeTemplate {
      id
      name
      type
      options
      archived
      createdAt
    }
  }
}
    `;
export type CreateSessionAttributeTemplateMutationFn = ApolloReactCommon.MutationFunction<CreateSessionAttributeTemplateMutation, CreateSessionAttributeTemplateMutationVariables>;

/**
 * __useCreateSessionAttributeTemplateMutation__
 *
 * To run a mutation, you first call `useCreateSessionAttributeTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionAttributeTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSessionAttributeTemplateMutation, { data, loading, error }] = useCreateSessionAttributeTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSessionAttributeTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSessionAttributeTemplateMutation, CreateSessionAttributeTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSessionAttributeTemplateMutation, CreateSessionAttributeTemplateMutationVariables>(CreateSessionAttributeTemplateDocument, options);
      }
export type CreateSessionAttributeTemplateMutationHookResult = ReturnType<typeof useCreateSessionAttributeTemplateMutation>;
export type CreateSessionAttributeTemplateMutationResult = ApolloReactCommon.MutationResult<CreateSessionAttributeTemplateMutation>;
export type CreateSessionAttributeTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSessionAttributeTemplateMutation, CreateSessionAttributeTemplateMutationVariables>;
export const DeleteOrganizationDocument = gql`
    mutation DeleteOrganization($input: DeleteOrganizationInput!) {
  deleteOrganization(input: $input) {
    success
  }
}
    `;
export type DeleteOrganizationMutationFn = ApolloReactCommon.MutationFunction<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, options);
      }
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = ApolloReactCommon.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const DuplicateSessionDocument = gql`
    mutation DuplicateSession($input: DuplicateSessionInput!) {
  duplicateSession(input: $input) {
    session {
      id
      title
      type
      description
      status
      createdAt
      focus
      defaultQuestions
      requireDefaultQuestions
      length
    }
  }
}
    `;
export type DuplicateSessionMutationFn = ApolloReactCommon.MutationFunction<DuplicateSessionMutation, DuplicateSessionMutationVariables>;

/**
 * __useDuplicateSessionMutation__
 *
 * To run a mutation, you first call `useDuplicateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateSessionMutation, { data, loading, error }] = useDuplicateSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DuplicateSessionMutation, DuplicateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DuplicateSessionMutation, DuplicateSessionMutationVariables>(DuplicateSessionDocument, options);
      }
export type DuplicateSessionMutationHookResult = ReturnType<typeof useDuplicateSessionMutation>;
export type DuplicateSessionMutationResult = ApolloReactCommon.MutationResult<DuplicateSessionMutation>;
export type DuplicateSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<DuplicateSessionMutation, DuplicateSessionMutationVariables>;
export const EndSessionDocument = gql`
    mutation EndSession($input: EndSessionInput!) {
  endSession(input: $input) {
    session {
      id
      expiresAt
      status
    }
  }
}
    `;
export type EndSessionMutationFn = ApolloReactCommon.MutationFunction<EndSessionMutation, EndSessionMutationVariables>;

/**
 * __useEndSessionMutation__
 *
 * To run a mutation, you first call `useEndSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endSessionMutation, { data, loading, error }] = useEndSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEndSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EndSessionMutation, EndSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EndSessionMutation, EndSessionMutationVariables>(EndSessionDocument, options);
      }
export type EndSessionMutationHookResult = ReturnType<typeof useEndSessionMutation>;
export type EndSessionMutationResult = ApolloReactCommon.MutationResult<EndSessionMutation>;
export type EndSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<EndSessionMutation, EndSessionMutationVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  currentUser {
    id
    email
    firstName
    lastName
    isPlatformAdmin
    source
    organization {
      id
      name
    }
    organizationOverridden
    organizationMemberships {
      id
      role
      organization {
        id
        name
      }
    }
    status
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserQueryResult = ApolloReactCommon.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetNextSolutionQuestionDocument = gql`
    query GetNextSolutionQuestion($solutionSessionId: ID!) {
  nextSolutionQuestion(solutionSessionId: $solutionSessionId) {
    id
    content {
      ... on TextQuestionContent {
        question
      }
    }
  }
}
    `;

/**
 * __useGetNextSolutionQuestionQuery__
 *
 * To run a query within a React component, call `useGetNextSolutionQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextSolutionQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextSolutionQuestionQuery({
 *   variables: {
 *      solutionSessionId: // value for 'solutionSessionId'
 *   },
 * });
 */
export function useGetNextSolutionQuestionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNextSolutionQuestionQuery, GetNextSolutionQuestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNextSolutionQuestionQuery, GetNextSolutionQuestionQueryVariables>(GetNextSolutionQuestionDocument, options);
      }
export function useGetNextSolutionQuestionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNextSolutionQuestionQuery, GetNextSolutionQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNextSolutionQuestionQuery, GetNextSolutionQuestionQueryVariables>(GetNextSolutionQuestionDocument, options);
        }
export type GetNextSolutionQuestionQueryHookResult = ReturnType<typeof useGetNextSolutionQuestionQuery>;
export type GetNextSolutionQuestionLazyQueryHookResult = ReturnType<typeof useGetNextSolutionQuestionLazyQuery>;
export type GetNextSolutionQuestionQueryResult = ApolloReactCommon.QueryResult<GetNextSolutionQuestionQuery, GetNextSolutionQuestionQueryVariables>;
export const GetOrganizationUsersDocument = gql`
    query GetOrganizationUsers($organizationId: ID!, $first: Int, $after: String, $last: Int, $before: String, $filter: OrganizationUsersFilterInput, $sort: [OrganizationUsersSortInput!]) {
  organizationUsers(
    organizationId: $organizationId
    first: $first
    after: $after
    last: $last
    before: $before
    filter: $filter
    sort: $sort
  ) {
    pageInfo {
      totalCount
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        id
        email
        firstName
        lastName
        source
        isPlatformAdmin
        status
        createdAt
        organizationMemberships {
          role
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUsersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetOrganizationUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>(GetOrganizationUsersDocument, options);
      }
export function useGetOrganizationUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>(GetOrganizationUsersDocument, options);
        }
export type GetOrganizationUsersQueryHookResult = ReturnType<typeof useGetOrganizationUsersQuery>;
export type GetOrganizationUsersLazyQueryHookResult = ReturnType<typeof useGetOrganizationUsersLazyQuery>;
export type GetOrganizationUsersQueryResult = ApolloReactCommon.QueryResult<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>;
export const GetOrganizationsDocument = gql`
    query GetOrganizations($first: Int, $after: String, $last: Int, $before: String, $filter: OrganizationsFilterInput) {
  organizations(
    first: $first
    after: $after
    last: $last
    before: $before
    filter: $filter
  ) {
    pageInfo {
      totalCount
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        name
        createdAt
        userCount
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsQueryResult = ApolloReactCommon.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetParticipantDocument = gql`
    query GetParticipant($sessionId: ID!, $participantId: ID!) {
  participant(sessionId: $sessionId, participantId: $participantId) {
    id
    name
    title
  }
}
    `;

/**
 * __useGetParticipantQuery__
 *
 * To run a query within a React component, call `useGetParticipantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetParticipantQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetParticipantQuery, GetParticipantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetParticipantQuery, GetParticipantQueryVariables>(GetParticipantDocument, options);
      }
export function useGetParticipantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetParticipantQuery, GetParticipantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetParticipantQuery, GetParticipantQueryVariables>(GetParticipantDocument, options);
        }
export type GetParticipantQueryHookResult = ReturnType<typeof useGetParticipantQuery>;
export type GetParticipantLazyQueryHookResult = ReturnType<typeof useGetParticipantLazyQuery>;
export type GetParticipantQueryResult = ApolloReactCommon.QueryResult<GetParticipantQuery, GetParticipantQueryVariables>;
export const GetParticipantAnswersDocument = gql`
    query GetParticipantAnswers($sessionId: ID!, $participantId: String!) {
  participantAnswers(
    filter: {sessionId: $sessionId, participantId: $participantId}
  ) {
    id
    content {
      ... on MultipleChoiceQuestionContent {
        question
        multipleChoiceOptions
      }
      ... on TextQuestionContent {
        question
      }
      ... on BooleanQuestionContent {
        question
      }
      ... on RankingQuestionContent {
        question
      }
      ... on RatingScaleQuestionContent {
        question
      }
    }
    answer
    answeredAt
  }
}
    `;

/**
 * __useGetParticipantAnswersQuery__
 *
 * To run a query within a React component, call `useGetParticipantAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantAnswersQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetParticipantAnswersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetParticipantAnswersQuery, GetParticipantAnswersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetParticipantAnswersQuery, GetParticipantAnswersQueryVariables>(GetParticipantAnswersDocument, options);
      }
export function useGetParticipantAnswersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetParticipantAnswersQuery, GetParticipantAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetParticipantAnswersQuery, GetParticipantAnswersQueryVariables>(GetParticipantAnswersDocument, options);
        }
export type GetParticipantAnswersQueryHookResult = ReturnType<typeof useGetParticipantAnswersQuery>;
export type GetParticipantAnswersLazyQueryHookResult = ReturnType<typeof useGetParticipantAnswersLazyQuery>;
export type GetParticipantAnswersQueryResult = ApolloReactCommon.QueryResult<GetParticipantAnswersQuery, GetParticipantAnswersQueryVariables>;
export const GetParticipantFactorScoresDocument = gql`
    query GetParticipantFactorScores($sessionId: ID!, $participantId: ID!) {
  participant(sessionId: $sessionId, participantId: $participantId) {
    id
    name
    title
    factorScores {
      id
      factorCode
      factorName
      sentiment
      sentimentLabel
      summary
    }
  }
}
    `;

/**
 * __useGetParticipantFactorScoresQuery__
 *
 * To run a query within a React component, call `useGetParticipantFactorScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantFactorScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantFactorScoresQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetParticipantFactorScoresQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetParticipantFactorScoresQuery, GetParticipantFactorScoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetParticipantFactorScoresQuery, GetParticipantFactorScoresQueryVariables>(GetParticipantFactorScoresDocument, options);
      }
export function useGetParticipantFactorScoresLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetParticipantFactorScoresQuery, GetParticipantFactorScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetParticipantFactorScoresQuery, GetParticipantFactorScoresQueryVariables>(GetParticipantFactorScoresDocument, options);
        }
export type GetParticipantFactorScoresQueryHookResult = ReturnType<typeof useGetParticipantFactorScoresQuery>;
export type GetParticipantFactorScoresLazyQueryHookResult = ReturnType<typeof useGetParticipantFactorScoresLazyQuery>;
export type GetParticipantFactorScoresQueryResult = ApolloReactCommon.QueryResult<GetParticipantFactorScoresQuery, GetParticipantFactorScoresQueryVariables>;
export const GetQuestionsDocument = gql`
    query GetQuestions($sessionId: ID!) {
  questions(filter: {sessionId: $sessionId}) {
    id
    content {
      ... on MultipleChoiceQuestionContent {
        question
        multipleChoiceOptions
      }
      ... on TextQuestionContent {
        question
      }
      ... on BooleanQuestionContent {
        question
      }
      ... on RatingScaleQuestionContent {
        preamble
        question
        scaleType
        minLabel
        maxLabel
      }
    }
    createdAt
  }
}
    `;

/**
 * __useGetQuestionsQuery__
 *
 * To run a query within a React component, call `useGetQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionsQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetQuestionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetQuestionsQuery, GetQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetQuestionsQuery, GetQuestionsQueryVariables>(GetQuestionsDocument, options);
      }
export function useGetQuestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuestionsQuery, GetQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetQuestionsQuery, GetQuestionsQueryVariables>(GetQuestionsDocument, options);
        }
export type GetQuestionsQueryHookResult = ReturnType<typeof useGetQuestionsQuery>;
export type GetQuestionsLazyQueryHookResult = ReturnType<typeof useGetQuestionsLazyQuery>;
export type GetQuestionsQueryResult = ApolloReactCommon.QueryResult<GetQuestionsQuery, GetQuestionsQueryVariables>;
export const GetSessionDocument = gql`
    query GetSession($id: ID!) {
  session(id: $id) {
    id
    title
    description
    status
    expiresAt
    startedAt
    sessionTimeRemaining
    sectionTimeRemaining
    length
    section
    createdAt
    type
    focus
    defaultQuestions
    requireDefaultQuestions
    allowExperimentalFactorQuestions
    identificationMode
    selectedAttributes {
      id
      name
      type
      options
    }
    currentParticipantHasJoined
    sections {
      name
      description
      section
      timeInSeconds
      timeRemaining
    }
    user {
      id
      email
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetSessionQuery__
 *
 * To run a query within a React component, call `useGetSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSessionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSessionQuery, GetSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionQuery, GetSessionQueryVariables>(GetSessionDocument, options);
      }
export function useGetSessionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionQuery, GetSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionQuery, GetSessionQueryVariables>(GetSessionDocument, options);
        }
export type GetSessionQueryHookResult = ReturnType<typeof useGetSessionQuery>;
export type GetSessionLazyQueryHookResult = ReturnType<typeof useGetSessionLazyQuery>;
export type GetSessionQueryResult = ApolloReactCommon.QueryResult<GetSessionQuery, GetSessionQueryVariables>;
export const GetSessionAttributeTemplatesDocument = gql`
    query GetSessionAttributeTemplates($filter: SessionAttributeTemplatesFilterInput, $first: Int, $after: String) {
  sessionAttributeTemplates(filter: $filter, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      totalCount
    }
    edges {
      cursor
      node {
        id
        name
        type
        options
        archived
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetSessionAttributeTemplatesQuery__
 *
 * To run a query within a React component, call `useGetSessionAttributeTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionAttributeTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionAttributeTemplatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetSessionAttributeTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSessionAttributeTemplatesQuery, GetSessionAttributeTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionAttributeTemplatesQuery, GetSessionAttributeTemplatesQueryVariables>(GetSessionAttributeTemplatesDocument, options);
      }
export function useGetSessionAttributeTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionAttributeTemplatesQuery, GetSessionAttributeTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionAttributeTemplatesQuery, GetSessionAttributeTemplatesQueryVariables>(GetSessionAttributeTemplatesDocument, options);
        }
export type GetSessionAttributeTemplatesQueryHookResult = ReturnType<typeof useGetSessionAttributeTemplatesQuery>;
export type GetSessionAttributeTemplatesLazyQueryHookResult = ReturnType<typeof useGetSessionAttributeTemplatesLazyQuery>;
export type GetSessionAttributeTemplatesQueryResult = ApolloReactCommon.QueryResult<GetSessionAttributeTemplatesQuery, GetSessionAttributeTemplatesQueryVariables>;
export const GetSessionFactorsDocument = gql`
    query GetSessionFactors($sessionId: ID!) {
  session(id: $sessionId) {
    id
    factors {
      status
      error
      factors {
        id
        factorCode
        factorName
        description
        analysis
        quotes {
          quote
          participant {
            id
            name
            title
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSessionFactorsQuery__
 *
 * To run a query within a React component, call `useGetSessionFactorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionFactorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionFactorsQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetSessionFactorsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSessionFactorsQuery, GetSessionFactorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionFactorsQuery, GetSessionFactorsQueryVariables>(GetSessionFactorsDocument, options);
      }
export function useGetSessionFactorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionFactorsQuery, GetSessionFactorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionFactorsQuery, GetSessionFactorsQueryVariables>(GetSessionFactorsDocument, options);
        }
export type GetSessionFactorsQueryHookResult = ReturnType<typeof useGetSessionFactorsQuery>;
export type GetSessionFactorsLazyQueryHookResult = ReturnType<typeof useGetSessionFactorsLazyQuery>;
export type GetSessionFactorsQueryResult = ApolloReactCommon.QueryResult<GetSessionFactorsQuery, GetSessionFactorsQueryVariables>;
export const GetSessionFeedbackDocument = gql`
    query GetSessionFeedback($sessionId: ID!) {
  session(id: $sessionId) {
    id
    title
    createdAt
    feedback {
      pageInfo {
        totalCount
      }
      edges {
        cursor
        node {
          id
          feedback
          rating
          createdAt
          participant {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSessionFeedbackQuery__
 *
 * To run a query within a React component, call `useGetSessionFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionFeedbackQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetSessionFeedbackQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSessionFeedbackQuery, GetSessionFeedbackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionFeedbackQuery, GetSessionFeedbackQueryVariables>(GetSessionFeedbackDocument, options);
      }
export function useGetSessionFeedbackLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionFeedbackQuery, GetSessionFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionFeedbackQuery, GetSessionFeedbackQueryVariables>(GetSessionFeedbackDocument, options);
        }
export type GetSessionFeedbackQueryHookResult = ReturnType<typeof useGetSessionFeedbackQuery>;
export type GetSessionFeedbackLazyQueryHookResult = ReturnType<typeof useGetSessionFeedbackLazyQuery>;
export type GetSessionFeedbackQueryResult = ApolloReactCommon.QueryResult<GetSessionFeedbackQuery, GetSessionFeedbackQueryVariables>;
export const GetSessionInsightsDocument = gql`
    query GetSessionInsights($sessionId: ID!) {
  sessionInsights(sessionId: $sessionId) {
    sessionInsights {
      sessionSummary {
        id
        positiveHighlights
        areasForImprovement
      }
      issues {
        id
        name
        description
        summary
        score
        topicAssignments {
          id
          email
          createdAt
        }
      }
      opportunities {
        id
        name
        description
        summary
        score
        topicAssignments {
          id
          email
          createdAt
        }
      }
      praise {
        id
        name
        description
        summary
        score
        topicAssignments {
          id
          email
          createdAt
        }
      }
      implementations {
        id
        name
        description
        summary
        score
        linkedIssueIds
        linkedOpportunityIds
      }
      participantCount
      duration
    }
  }
}
    `;

/**
 * __useGetSessionInsightsQuery__
 *
 * To run a query within a React component, call `useGetSessionInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionInsightsQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetSessionInsightsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSessionInsightsQuery, GetSessionInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionInsightsQuery, GetSessionInsightsQueryVariables>(GetSessionInsightsDocument, options);
      }
export function useGetSessionInsightsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionInsightsQuery, GetSessionInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionInsightsQuery, GetSessionInsightsQueryVariables>(GetSessionInsightsDocument, options);
        }
export type GetSessionInsightsQueryHookResult = ReturnType<typeof useGetSessionInsightsQuery>;
export type GetSessionInsightsLazyQueryHookResult = ReturnType<typeof useGetSessionInsightsLazyQuery>;
export type GetSessionInsightsQueryResult = ApolloReactCommon.QueryResult<GetSessionInsightsQuery, GetSessionInsightsQueryVariables>;
export const GetSessionLogsDocument = gql`
    query GetSessionLogs($id: ID!) {
  session(id: $id) {
    id
    logs {
      id
      sessionId
      level
      data
      createdAt
    }
  }
}
    `;

/**
 * __useGetSessionLogsQuery__
 *
 * To run a query within a React component, call `useGetSessionLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionLogsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSessionLogsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSessionLogsQuery, GetSessionLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionLogsQuery, GetSessionLogsQueryVariables>(GetSessionLogsDocument, options);
      }
export function useGetSessionLogsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionLogsQuery, GetSessionLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionLogsQuery, GetSessionLogsQueryVariables>(GetSessionLogsDocument, options);
        }
export type GetSessionLogsQueryHookResult = ReturnType<typeof useGetSessionLogsQuery>;
export type GetSessionLogsLazyQueryHookResult = ReturnType<typeof useGetSessionLogsLazyQuery>;
export type GetSessionLogsQueryResult = ApolloReactCommon.QueryResult<GetSessionLogsQuery, GetSessionLogsQueryVariables>;
export const GetSessionParticipantsDocument = gql`
    query GetSessionParticipants($sessionId: ID!, $first: Int, $after: String, $last: Int, $before: String, $sort: [ParticipantsSortInput!], $filter: SessionParticipantsFilterInput) {
  session(id: $sessionId) {
    id
    participants(
      first: $first
      after: $after
      last: $last
      before: $before
      sort: $sort
      filter: $filter
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
        totalCount
      }
      edges {
        cursor
        node {
          id
          name
          title
          email
          attributeResponses {
            attributeTemplate {
              id
              name
            }
            value
          }
          factorScores {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSessionParticipantsQuery__
 *
 * To run a query within a React component, call `useGetSessionParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionParticipantsQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSessionParticipantsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSessionParticipantsQuery, GetSessionParticipantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionParticipantsQuery, GetSessionParticipantsQueryVariables>(GetSessionParticipantsDocument, options);
      }
export function useGetSessionParticipantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionParticipantsQuery, GetSessionParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionParticipantsQuery, GetSessionParticipantsQueryVariables>(GetSessionParticipantsDocument, options);
        }
export type GetSessionParticipantsQueryHookResult = ReturnType<typeof useGetSessionParticipantsQuery>;
export type GetSessionParticipantsLazyQueryHookResult = ReturnType<typeof useGetSessionParticipantsLazyQuery>;
export type GetSessionParticipantsQueryResult = ApolloReactCommon.QueryResult<GetSessionParticipantsQuery, GetSessionParticipantsQueryVariables>;
export const GetSessionsDocument = gql`
    query GetSessions($first: Int, $after: String, $last: Int, $before: String, $filter: SessionsFilterInput, $sort: [SessionsSortInput!]) {
  sessions(
    first: $first
    after: $after
    last: $last
    before: $before
    filter: $filter
    sort: $sort
  ) {
    pageInfo {
      totalCount
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        id
        title
        status
        createdAt
        user {
          id
          firstName
          lastName
        }
        participants(first: 0) {
          pageInfo {
            totalCount
          }
        }
        feedback(first: 0) {
          pageInfo {
            totalCount
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSessionsQuery__
 *
 * To run a query within a React component, call `useGetSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetSessionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSessionsQuery, GetSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionsQuery, GetSessionsQueryVariables>(GetSessionsDocument, options);
      }
export function useGetSessionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionsQuery, GetSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionsQuery, GetSessionsQueryVariables>(GetSessionsDocument, options);
        }
export type GetSessionsQueryHookResult = ReturnType<typeof useGetSessionsQuery>;
export type GetSessionsLazyQueryHookResult = ReturnType<typeof useGetSessionsLazyQuery>;
export type GetSessionsQueryResult = ApolloReactCommon.QueryResult<GetSessionsQuery, GetSessionsQueryVariables>;
export const GetUserOrganizationsDocument = gql`
    query GetUserOrganizations($userId: ID!) {
  user(id: $userId) {
    id
    organizationMemberships {
      id
      user {
        id
        email
        firstName
        lastName
      }
      organization {
        id
        name
        createdAt
        userCount
      }
      role
    }
  }
}
    `;

/**
 * __useGetUserOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetUserOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOrganizationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserOrganizationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserOrganizationsQuery, GetUserOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserOrganizationsQuery, GetUserOrganizationsQueryVariables>(GetUserOrganizationsDocument, options);
      }
export function useGetUserOrganizationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserOrganizationsQuery, GetUserOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserOrganizationsQuery, GetUserOrganizationsQueryVariables>(GetUserOrganizationsDocument, options);
        }
export type GetUserOrganizationsQueryHookResult = ReturnType<typeof useGetUserOrganizationsQuery>;
export type GetUserOrganizationsLazyQueryHookResult = ReturnType<typeof useGetUserOrganizationsLazyQuery>;
export type GetUserOrganizationsQueryResult = ApolloReactCommon.QueryResult<GetUserOrganizationsQuery, GetUserOrganizationsQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers($first: Int, $after: String, $last: Int, $before: String, $filter: UsersFilterInput, $sort: [UsersSortInput!]) {
  users(
    first: $first
    after: $after
    last: $last
    before: $before
    filter: $filter
    sort: $sort
  ) {
    pageInfo {
      totalCount
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        id
        email
        firstName
        lastName
        source
        isPlatformAdmin
        status
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = ApolloReactCommon.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const JoinSessionDocument = gql`
    mutation JoinSession($input: JoinSessionInput!) {
  joinSession(input: $input) {
    session {
      id
      currentParticipantHasJoined
    }
    participant {
      id
      name
      title
      email
    }
  }
}
    `;
export type JoinSessionMutationFn = ApolloReactCommon.MutationFunction<JoinSessionMutation, JoinSessionMutationVariables>;

/**
 * __useJoinSessionMutation__
 *
 * To run a mutation, you first call `useJoinSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinSessionMutation, { data, loading, error }] = useJoinSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJoinSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<JoinSessionMutation, JoinSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<JoinSessionMutation, JoinSessionMutationVariables>(JoinSessionDocument, options);
      }
export type JoinSessionMutationHookResult = ReturnType<typeof useJoinSessionMutation>;
export type JoinSessionMutationResult = ApolloReactCommon.MutationResult<JoinSessionMutation>;
export type JoinSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<JoinSessionMutation, JoinSessionMutationVariables>;
export const NextQuestionDocument = gql`
    query NextQuestion($sessionId: ID!) {
  nextQuestion(sessionId: $sessionId) {
    session {
      id
      type
      status
      section
      sections {
        name
        description
        section
        timeInSeconds
        timeRemaining
      }
      user {
        id
        email
        firstName
        lastName
      }
      title
      currentParticipantHasJoined
    }
    question {
      id
      createdAt
      section
      issues {
        id
        name
        description
      }
      opportunities {
        id
        name
        description
      }
      implementations {
        id
        name
        description
      }
      content {
        ... on MultipleChoiceQuestionContent {
          preamble
          question
          multipleChoiceOptions
        }
        ... on TextQuestionContent {
          preamble
          question
        }
        ... on BooleanQuestionContent {
          preamble
          question
        }
        ... on RankingQuestionContent {
          preamble
          question
          rankingType
          issues {
            id
            name
            description
          }
          opportunities {
            id
            name
            description
          }
          rankingOptions {
            id
            text
            description
          }
        }
        ... on RatingScaleQuestionContent {
          preamble
          question
          scaleType
          minLabel
          maxLabel
        }
      }
    }
  }
}
    `;

/**
 * __useNextQuestionQuery__
 *
 * To run a query within a React component, call `useNextQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextQuestionQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useNextQuestionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NextQuestionQuery, NextQuestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NextQuestionQuery, NextQuestionQueryVariables>(NextQuestionDocument, options);
      }
export function useNextQuestionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NextQuestionQuery, NextQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NextQuestionQuery, NextQuestionQueryVariables>(NextQuestionDocument, options);
        }
export type NextQuestionQueryHookResult = ReturnType<typeof useNextQuestionQuery>;
export type NextQuestionLazyQueryHookResult = ReturnType<typeof useNextQuestionLazyQuery>;
export type NextQuestionQueryResult = ApolloReactCommon.QueryResult<NextQuestionQuery, NextQuestionQueryVariables>;
export const PauseSessionDocument = gql`
    mutation PauseSession($input: PauseSessionInput!) {
  pauseSession(input: $input) {
    session {
      id
      status
      user {
        id
      }
    }
  }
}
    `;
export type PauseSessionMutationFn = ApolloReactCommon.MutationFunction<PauseSessionMutation, PauseSessionMutationVariables>;

/**
 * __usePauseSessionMutation__
 *
 * To run a mutation, you first call `usePauseSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseSessionMutation, { data, loading, error }] = usePauseSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePauseSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PauseSessionMutation, PauseSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PauseSessionMutation, PauseSessionMutationVariables>(PauseSessionDocument, options);
      }
export type PauseSessionMutationHookResult = ReturnType<typeof usePauseSessionMutation>;
export type PauseSessionMutationResult = ApolloReactCommon.MutationResult<PauseSessionMutation>;
export type PauseSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<PauseSessionMutation, PauseSessionMutationVariables>;
export const RegenerateSessionSummaryDocument = gql`
    mutation RegenerateSessionSummary($sessionId: ID!) {
  regenerateSessionSummary(input: {sessionId: $sessionId}) {
    success
  }
}
    `;
export type RegenerateSessionSummaryMutationFn = ApolloReactCommon.MutationFunction<RegenerateSessionSummaryMutation, RegenerateSessionSummaryMutationVariables>;

/**
 * __useRegenerateSessionSummaryMutation__
 *
 * To run a mutation, you first call `useRegenerateSessionSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateSessionSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateSessionSummaryMutation, { data, loading, error }] = useRegenerateSessionSummaryMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useRegenerateSessionSummaryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegenerateSessionSummaryMutation, RegenerateSessionSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RegenerateSessionSummaryMutation, RegenerateSessionSummaryMutationVariables>(RegenerateSessionSummaryDocument, options);
      }
export type RegenerateSessionSummaryMutationHookResult = ReturnType<typeof useRegenerateSessionSummaryMutation>;
export type RegenerateSessionSummaryMutationResult = ApolloReactCommon.MutationResult<RegenerateSessionSummaryMutation>;
export type RegenerateSessionSummaryMutationOptions = ApolloReactCommon.BaseMutationOptions<RegenerateSessionSummaryMutation, RegenerateSessionSummaryMutationVariables>;
export const RemoveTopicAssignmentDocument = gql`
    mutation RemoveTopicAssignment($input: RemoveTopicAssignmentInput!) {
  removeTopicAssignment(input: $input) {
    success
    idea {
      ... on Issue {
        id
        topicAssignments {
          id
          email
          createdAt
        }
      }
      ... on Opportunity {
        id
        topicAssignments {
          id
          email
          createdAt
        }
      }
      ... on Praise {
        id
        topicAssignments {
          id
          email
          createdAt
        }
      }
    }
  }
}
    `;
export type RemoveTopicAssignmentMutationFn = ApolloReactCommon.MutationFunction<RemoveTopicAssignmentMutation, RemoveTopicAssignmentMutationVariables>;

/**
 * __useRemoveTopicAssignmentMutation__
 *
 * To run a mutation, you first call `useRemoveTopicAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTopicAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTopicAssignmentMutation, { data, loading, error }] = useRemoveTopicAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveTopicAssignmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveTopicAssignmentMutation, RemoveTopicAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveTopicAssignmentMutation, RemoveTopicAssignmentMutationVariables>(RemoveTopicAssignmentDocument, options);
      }
export type RemoveTopicAssignmentMutationHookResult = ReturnType<typeof useRemoveTopicAssignmentMutation>;
export type RemoveTopicAssignmentMutationResult = ApolloReactCommon.MutationResult<RemoveTopicAssignmentMutation>;
export type RemoveTopicAssignmentMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveTopicAssignmentMutation, RemoveTopicAssignmentMutationVariables>;
export const RemoveUserFromOrganizationDocument = gql`
    mutation RemoveUserFromOrganization($input: RemoveUserFromOrganizationInput!) {
  removeUserFromOrganization(input: $input) {
    success
  }
}
    `;
export type RemoveUserFromOrganizationMutationFn = ApolloReactCommon.MutationFunction<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>;

/**
 * __useRemoveUserFromOrganizationMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromOrganizationMutation, { data, loading, error }] = useRemoveUserFromOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUserFromOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>(RemoveUserFromOrganizationDocument, options);
      }
export type RemoveUserFromOrganizationMutationHookResult = ReturnType<typeof useRemoveUserFromOrganizationMutation>;
export type RemoveUserFromOrganizationMutationResult = ApolloReactCommon.MutationResult<RemoveUserFromOrganizationMutation>;
export type RemoveUserFromOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>;
export const ResumeSessionDocument = gql`
    mutation ResumeSession($input: ResumeSessionInput!) {
  resumeSession(input: $input) {
    session {
      id
      status
      user {
        id
      }
    }
  }
}
    `;
export type ResumeSessionMutationFn = ApolloReactCommon.MutationFunction<ResumeSessionMutation, ResumeSessionMutationVariables>;

/**
 * __useResumeSessionMutation__
 *
 * To run a mutation, you first call `useResumeSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeSessionMutation, { data, loading, error }] = useResumeSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResumeSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResumeSessionMutation, ResumeSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResumeSessionMutation, ResumeSessionMutationVariables>(ResumeSessionDocument, options);
      }
export type ResumeSessionMutationHookResult = ReturnType<typeof useResumeSessionMutation>;
export type ResumeSessionMutationResult = ApolloReactCommon.MutationResult<ResumeSessionMutation>;
export type ResumeSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<ResumeSessionMutation, ResumeSessionMutationVariables>;
export const SaveVoteDocument = gql`
    mutation SaveVote($input: SaveVoteInput!) {
  saveVote(input: $input) {
    success
    opportunity {
      id
      myVote
      score
    }
    implementation {
      id
      myVote
      score
    }
    issue {
      id
      myVote
      score
    }
  }
}
    `;
export type SaveVoteMutationFn = ApolloReactCommon.MutationFunction<SaveVoteMutation, SaveVoteMutationVariables>;

/**
 * __useSaveVoteMutation__
 *
 * To run a mutation, you first call `useSaveVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveVoteMutation, { data, loading, error }] = useSaveVoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveVoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveVoteMutation, SaveVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveVoteMutation, SaveVoteMutationVariables>(SaveVoteDocument, options);
      }
export type SaveVoteMutationHookResult = ReturnType<typeof useSaveVoteMutation>;
export type SaveVoteMutationResult = ApolloReactCommon.MutationResult<SaveVoteMutation>;
export type SaveVoteMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveVoteMutation, SaveVoteMutationVariables>;
export const SendInsightsEmailDocument = gql`
    mutation SendInsightsEmail($input: SendInsightsEmailInput!) {
  sendInsightsEmail(input: $input) {
    success
    emailsSent
  }
}
    `;
export type SendInsightsEmailMutationFn = ApolloReactCommon.MutationFunction<SendInsightsEmailMutation, SendInsightsEmailMutationVariables>;

/**
 * __useSendInsightsEmailMutation__
 *
 * To run a mutation, you first call `useSendInsightsEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInsightsEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInsightsEmailMutation, { data, loading, error }] = useSendInsightsEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendInsightsEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendInsightsEmailMutation, SendInsightsEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendInsightsEmailMutation, SendInsightsEmailMutationVariables>(SendInsightsEmailDocument, options);
      }
export type SendInsightsEmailMutationHookResult = ReturnType<typeof useSendInsightsEmailMutation>;
export type SendInsightsEmailMutationResult = ApolloReactCommon.MutationResult<SendInsightsEmailMutation>;
export type SendInsightsEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<SendInsightsEmailMutation, SendInsightsEmailMutationVariables>;
export const SendInvitationDocument = gql`
    mutation SendInvitation($input: SendInvitationInput!) {
  sendInvitation(input: $input) {
    invitationSent
    error
    success
  }
}
    `;
export type SendInvitationMutationFn = ApolloReactCommon.MutationFunction<SendInvitationMutation, SendInvitationMutationVariables>;

/**
 * __useSendInvitationMutation__
 *
 * To run a mutation, you first call `useSendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitationMutation, { data, loading, error }] = useSendInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendInvitationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendInvitationMutation, SendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendInvitationMutation, SendInvitationMutationVariables>(SendInvitationDocument, options);
      }
export type SendInvitationMutationHookResult = ReturnType<typeof useSendInvitationMutation>;
export type SendInvitationMutationResult = ApolloReactCommon.MutationResult<SendInvitationMutation>;
export type SendInvitationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendInvitationMutation, SendInvitationMutationVariables>;
export const SkipQuestionDocument = gql`
    mutation SkipQuestion($input: SkipQuestionInput!) {
  skipQuestion(input: $input) {
    answer
    answeredAt
  }
}
    `;
export type SkipQuestionMutationFn = ApolloReactCommon.MutationFunction<SkipQuestionMutation, SkipQuestionMutationVariables>;

/**
 * __useSkipQuestionMutation__
 *
 * To run a mutation, you first call `useSkipQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipQuestionMutation, { data, loading, error }] = useSkipQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSkipQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SkipQuestionMutation, SkipQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SkipQuestionMutation, SkipQuestionMutationVariables>(SkipQuestionDocument, options);
      }
export type SkipQuestionMutationHookResult = ReturnType<typeof useSkipQuestionMutation>;
export type SkipQuestionMutationResult = ApolloReactCommon.MutationResult<SkipQuestionMutation>;
export type SkipQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<SkipQuestionMutation, SkipQuestionMutationVariables>;
export const SkipToNextSectionDocument = gql`
    mutation SkipToNextSection($input: SkipToNextSectionInput!) {
  skipToNextSection(input: $input) {
    session {
      id
      sections {
        section
        timeRemaining
      }
    }
    newSectionIndex
  }
}
    `;
export type SkipToNextSectionMutationFn = ApolloReactCommon.MutationFunction<SkipToNextSectionMutation, SkipToNextSectionMutationVariables>;

/**
 * __useSkipToNextSectionMutation__
 *
 * To run a mutation, you first call `useSkipToNextSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipToNextSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipToNextSectionMutation, { data, loading, error }] = useSkipToNextSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSkipToNextSectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SkipToNextSectionMutation, SkipToNextSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SkipToNextSectionMutation, SkipToNextSectionMutationVariables>(SkipToNextSectionDocument, options);
      }
export type SkipToNextSectionMutationHookResult = ReturnType<typeof useSkipToNextSectionMutation>;
export type SkipToNextSectionMutationResult = ApolloReactCommon.MutationResult<SkipToNextSectionMutation>;
export type SkipToNextSectionMutationOptions = ApolloReactCommon.BaseMutationOptions<SkipToNextSectionMutation, SkipToNextSectionMutationVariables>;
export const StartSessionDocument = gql`
    mutation StartSession($input: StartSessionInput!) {
  startSession(input: $input) {
    expiresAt
  }
}
    `;
export type StartSessionMutationFn = ApolloReactCommon.MutationFunction<StartSessionMutation, StartSessionMutationVariables>;

/**
 * __useStartSessionMutation__
 *
 * To run a mutation, you first call `useStartSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSessionMutation, { data, loading, error }] = useStartSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartSessionMutation, StartSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartSessionMutation, StartSessionMutationVariables>(StartSessionDocument, options);
      }
export type StartSessionMutationHookResult = ReturnType<typeof useStartSessionMutation>;
export type StartSessionMutationResult = ApolloReactCommon.MutationResult<StartSessionMutation>;
export type StartSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<StartSessionMutation, StartSessionMutationVariables>;
export const StartSolutionForIdeaDocument = gql`
    mutation StartSolutionForIdea($input: StartSolutionForIdeaInput!) {
  startSolutionForIdea(input: $input) {
    solutionSessionId
    nextQuestion {
      id
      content {
        ... on TextQuestionContent {
          question
        }
      }
    }
  }
}
    `;
export type StartSolutionForIdeaMutationFn = ApolloReactCommon.MutationFunction<StartSolutionForIdeaMutation, StartSolutionForIdeaMutationVariables>;

/**
 * __useStartSolutionForIdeaMutation__
 *
 * To run a mutation, you first call `useStartSolutionForIdeaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSolutionForIdeaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSolutionForIdeaMutation, { data, loading, error }] = useStartSolutionForIdeaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartSolutionForIdeaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartSolutionForIdeaMutation, StartSolutionForIdeaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartSolutionForIdeaMutation, StartSolutionForIdeaMutationVariables>(StartSolutionForIdeaDocument, options);
      }
export type StartSolutionForIdeaMutationHookResult = ReturnType<typeof useStartSolutionForIdeaMutation>;
export type StartSolutionForIdeaMutationResult = ApolloReactCommon.MutationResult<StartSolutionForIdeaMutation>;
export type StartSolutionForIdeaMutationOptions = ApolloReactCommon.BaseMutationOptions<StartSolutionForIdeaMutation, StartSolutionForIdeaMutationVariables>;
export const ToggleCurrentUserPlatformAdminDocument = gql`
    mutation ToggleCurrentUserPlatformAdmin {
  toggleCurrentUserPlatformAdmin {
    user {
      id
      email
      firstName
      lastName
      isPlatformAdmin
      source
    }
  }
}
    `;
export type ToggleCurrentUserPlatformAdminMutationFn = ApolloReactCommon.MutationFunction<ToggleCurrentUserPlatformAdminMutation, ToggleCurrentUserPlatformAdminMutationVariables>;

/**
 * __useToggleCurrentUserPlatformAdminMutation__
 *
 * To run a mutation, you first call `useToggleCurrentUserPlatformAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCurrentUserPlatformAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCurrentUserPlatformAdminMutation, { data, loading, error }] = useToggleCurrentUserPlatformAdminMutation({
 *   variables: {
 *   },
 * });
 */
export function useToggleCurrentUserPlatformAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleCurrentUserPlatformAdminMutation, ToggleCurrentUserPlatformAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleCurrentUserPlatformAdminMutation, ToggleCurrentUserPlatformAdminMutationVariables>(ToggleCurrentUserPlatformAdminDocument, options);
      }
export type ToggleCurrentUserPlatformAdminMutationHookResult = ReturnType<typeof useToggleCurrentUserPlatformAdminMutation>;
export type ToggleCurrentUserPlatformAdminMutationResult = ApolloReactCommon.MutationResult<ToggleCurrentUserPlatformAdminMutation>;
export type ToggleCurrentUserPlatformAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleCurrentUserPlatformAdminMutation, ToggleCurrentUserPlatformAdminMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    organization {
      id
      name
    }
  }
}
    `;
export type UpdateOrganizationMutationFn = ApolloReactCommon.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpdateSessionDocument = gql`
    mutation UpdateSession($input: UpdateSessionInput!) {
  updateSession(input: $input) {
    session {
      id
      title
      type
      description
      status
      createdAt
      focus
      defaultQuestions
      requireDefaultQuestions
      allowExperimentalFactorQuestions
      identificationMode
      selectedAttributes {
        id
        name
        type
        options
      }
    }
  }
}
    `;
export type UpdateSessionMutationFn = ApolloReactCommon.MutationFunction<UpdateSessionMutation, UpdateSessionMutationVariables>;

/**
 * __useUpdateSessionMutation__
 *
 * To run a mutation, you first call `useUpdateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionMutation, { data, loading, error }] = useUpdateSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSessionMutation, UpdateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSessionMutation, UpdateSessionMutationVariables>(UpdateSessionDocument, options);
      }
export type UpdateSessionMutationHookResult = ReturnType<typeof useUpdateSessionMutation>;
export type UpdateSessionMutationResult = ApolloReactCommon.MutationResult<UpdateSessionMutation>;
export type UpdateSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSessionMutation, UpdateSessionMutationVariables>;
export const UpdateSessionAttributeTemplateDocument = gql`
    mutation UpdateSessionAttributeTemplate($input: UpdateSessionAttributeTemplateInput!) {
  updateSessionAttributeTemplate(input: $input) {
    sessionAttributeTemplate {
      id
      name
      type
      options
      archived
      createdAt
    }
  }
}
    `;
export type UpdateSessionAttributeTemplateMutationFn = ApolloReactCommon.MutationFunction<UpdateSessionAttributeTemplateMutation, UpdateSessionAttributeTemplateMutationVariables>;

/**
 * __useUpdateSessionAttributeTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateSessionAttributeTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionAttributeTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionAttributeTemplateMutation, { data, loading, error }] = useUpdateSessionAttributeTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSessionAttributeTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSessionAttributeTemplateMutation, UpdateSessionAttributeTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSessionAttributeTemplateMutation, UpdateSessionAttributeTemplateMutationVariables>(UpdateSessionAttributeTemplateDocument, options);
      }
export type UpdateSessionAttributeTemplateMutationHookResult = ReturnType<typeof useUpdateSessionAttributeTemplateMutation>;
export type UpdateSessionAttributeTemplateMutationResult = ApolloReactCommon.MutationResult<UpdateSessionAttributeTemplateMutation>;
export type UpdateSessionAttributeTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSessionAttributeTemplateMutation, UpdateSessionAttributeTemplateMutationVariables>;
export const UpdateUserOrganizationRoleDocument = gql`
    mutation UpdateUserOrganizationRole($input: UpdateUserOrganizationRoleInput!) {
  updateUserOrganizationRole(input: $input) {
    userOrganization {
      id
      user {
        id
        email
        firstName
        lastName
      }
      organization {
        id
        name
        createdAt
        userCount
      }
      role
    }
  }
}
    `;
export type UpdateUserOrganizationRoleMutationFn = ApolloReactCommon.MutationFunction<UpdateUserOrganizationRoleMutation, UpdateUserOrganizationRoleMutationVariables>;

/**
 * __useUpdateUserOrganizationRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserOrganizationRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOrganizationRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOrganizationRoleMutation, { data, loading, error }] = useUpdateUserOrganizationRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserOrganizationRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserOrganizationRoleMutation, UpdateUserOrganizationRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserOrganizationRoleMutation, UpdateUserOrganizationRoleMutationVariables>(UpdateUserOrganizationRoleDocument, options);
      }
export type UpdateUserOrganizationRoleMutationHookResult = ReturnType<typeof useUpdateUserOrganizationRoleMutation>;
export type UpdateUserOrganizationRoleMutationResult = ApolloReactCommon.MutationResult<UpdateUserOrganizationRoleMutation>;
export type UpdateUserOrganizationRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserOrganizationRoleMutation, UpdateUserOrganizationRoleMutationVariables>;
export const SendFeedbackDocument = gql`
    mutation SendFeedback($input: CreateFeedbackInput!) {
  createFeedback(input: $input) {
    feedback {
      id
      feedback
      rating
      participant {
        id
        name
      }
    }
  }
}
    `;
export type SendFeedbackMutationFn = ApolloReactCommon.MutationFunction<SendFeedbackMutation, SendFeedbackMutationVariables>;

/**
 * __useSendFeedbackMutation__
 *
 * To run a mutation, you first call `useSendFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFeedbackMutation, { data, loading, error }] = useSendFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendFeedbackMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendFeedbackMutation, SendFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendFeedbackMutation, SendFeedbackMutationVariables>(SendFeedbackDocument, options);
      }
export type SendFeedbackMutationHookResult = ReturnType<typeof useSendFeedbackMutation>;
export type SendFeedbackMutationResult = ApolloReactCommon.MutationResult<SendFeedbackMutation>;
export type SendFeedbackMutationOptions = ApolloReactCommon.BaseMutationOptions<SendFeedbackMutation, SendFeedbackMutationVariables>;